(function() {
  'use strict';
  if (window.__gmInit) return;
  window.__gmInit = true;

  var root = document.querySelector('.gm-root');
  if (!root) return;

  // Bound requests that otherwise leave the checkout button on Saving forever. The 12s cap runs until
  // the body has been read as well: a response whose headers arrive but whose body stalls must still end.
  function gmFetchWithTimeout(url, options) {
    var controller = new AbortController();
    var timer = setTimeout(function() { controller.abort(); }, 12000);
    return fetch(url, Object.assign({}, options, { signal: controller.signal })).then(function(r) {
      var json = r.json.bind(r);
      r.json = function() { return json().finally(function() { clearTimeout(timer); }); };
      return r;
    }, function(err) { clearTimeout(timer); throw err; });
  }

  // A UI timeout cannot cancel a mutation already received by Shopify. Keep that request in the
  // queue until its full response arrives, and remember an unknown outcome across a page reload.
  var gmCartSaveChain = Promise.resolve();
  var gmCartSaveKey = 'ss-gift-cart-save-pending';
  var gmCartSaveUncertain = false;
  try { gmCartSaveUncertain = !!sessionStorage.getItem(gmCartSaveKey); } catch (_) {}
  var gmCartSaveUnknownMessage = 'We could not confirm that your basket saved. Your draft is still here. Please contact us before trying checkout again.';

  function gmSaveCart(attributes, live) {
    var wanted = true;
    var save = gmCartSaveChain.then(function() {
      if (!wanted || !live()) return null;
      if (gmCartSaveUncertain) throw new Error(gmCartSaveUnknownMessage);
      var complete = false;
      try { sessionStorage.setItem(gmCartSaveKey, 'pending'); } catch (_) {}
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      }).then(function(r) {
        return r.text().then(function(body) {
          complete = true;
          try { sessionStorage.removeItem(gmCartSaveKey); } catch (_) {}
          var cart = JSON.parse(body);
          if (!r.ok) throw new Error(cart.description || 'Save failed');
          return cart;
        });
      }).catch(function(err) {
        if (!complete) gmCartSaveUncertain = true;
        throw err;
      });
    });
    gmCartSaveChain = save.catch(function() {});
    return new Promise(function(resolve, reject) {
      var timer = setTimeout(function() {
        wanted = false;
        var err = new Error('Your gift details are taking longer to save. Your draft is still here. Please wait a moment, then try again.');
        err.gmSaveTimeout = true;
        reject(err);
      }, 12000);
      save.then(function(cart) {
        clearTimeout(timer);
        if (wanted) resolve(cart);
      }, function(err) {
        clearTimeout(timer);
        if (wanted) reject(err);
      });
    });
  }

  // ─── Form state - mirrors v2 INITIAL shape ────────────────────────────
  var form = {
    first: '', last: '', rel: '', occ: '',
    tone: '', message: '',
    photoAttached: false, attachmentURL: '',
    hintEnabled: false, hint: '', secretWord: '',
    emailUnlock: false, email: '',   // opt-in default - user must tick before entering an address
    smsUnlock: false, phone: ''
  };
  var step = 1;       // internal step 1..3 (= journey step 2..4)
  var done = {};      // completed steps (drives tab "is-done" state)
  var dirty = false;  // user has typed anything? → confirm-on-close
  var lastTrigger = null;
  var errorTimer = null;
  var mediaNudged = false; // one-time gentle "add a photo?" nudge on leaving the Message step
  var nudgeEl = null;
  var ownsBodyLock = false;
  var openFrameToken = 0;

  var gmUploadAttempt = null;
  var gmUploadToken = 0;

  function gmUploadCurrent(attempt) {
    return !!attempt && gmUploadAttempt === attempt && !attempt.cancelled;
  }

  // Non-blocking uploads (2026-10-06): an upload keeps running while the sender
  // moves through Delivery and Review; only the final commit waits for it.
  function gmUploadInFlight() {
    return !!gmUploadAttempt && !gmUploadAttempt.cancelled && !gmUploadAttempt.finished;
  }

  function gmInvalidateUpload() {
    gmCancelCommit();
    gmUploadToken++;
    var previous = gmUploadAttempt;
    gmUploadAttempt = null;
    if (!previous) return;
    previous.cancelled = true;
    previous.timers.forEach(clearTimeout);
    previous.controllers.forEach(function(c) { c.abort(); });
    previous.xhrs.forEach(function(xhr) { xhr.abort(); });
    (previous.cleanups || []).forEach(function(cleanup) { cleanup(); });
  }

  function gmUploadLater(attempt, fn, delay) {
    var timer = setTimeout(function() { if (gmUploadCurrent(attempt)) fn(); }, delay);
    attempt.timers.push(timer);
    return timer;
  }

  function gmBeginUpload(file) {
    gmInvalidateUpload();
    var oldBanner = root.querySelector('[data-gm-error]');
    if (oldBanner) oldBanner.hidden = true;
    var attempt = { token: gmUploadToken, cancelled: false, finished: false, timers: [], controllers: [], xhrs: [], video: gmFileType(file).indexOf('video/') === 0 };
    gmUploadAttempt = attempt;
    form.attachmentURL = '';
    form._uploadMeta = null;
    gmResetThumb();
    syncHintAvailability(true);
    gmUploadLater(attempt, function() {
      gmUploadFail(attempt, 'Upload timed out. Check your connection and try again.');
    }, gmFileType(file).indexOf('video/') === 0 ? gmVideoTransferMs(file) + 2 * 60 * 1000 : 4 * 60 * 1000);
    return attempt;
  }

  // A big clip on a weak uplink is slow, not stuck: allow ~1.2 Mbps (150 KB/s), never under 5 minutes,
  // and never past 27 minutes (Stream's one-shot upload URL expires at 30). Stalls are caught separately.
  function gmVideoTransferMs(file) {
    // resumable uploads carry their own 6-hour upload URL, so a very large clip may take longer
    var cap = (file.size || 0) > GM_MAX_BYTES ? 120 * 60 * 1000 : 27 * 60 * 1000;
    return Math.min(cap, Math.max(5 * 60 * 1000, Math.round((file.size || 0) / 150)));
  }

  function gmUploadFail(attempt, text) {
    if (!gmUploadCurrent(attempt)) return;
    if (/failed to fetch|networkerror|load failed|network request failed/i.test(text || '')) text = 'Upload failed - check your connection and try again.';
    gmInvalidateUpload();
    form.attachmentURL = '';
    form._uploadMeta = null;
    if (photoMount) photoMount.classList.remove('is-attached');
    if (photoToggle) photoToggle.classList.remove('is-attached');
    uploadShowError(text);
    gmAnnounce(text);
    gmHintOffKeepDraft();
    var reviewHint = root.querySelector('[data-gm-review-photohint]');
    if (reviewHint && reviewHint.parentNode) reviewHint.parentNode.removeChild(reviewHint);
    if (step !== 1) showError('Your photo or video didn\u2019t upload. Go back to Message to try again, or remove it.');
  }

  function gmClearUpload() {
    gmInvalidateUpload();
    form.attachmentURL = '';
    form.photoAttached = false;
    form._uploadMeta = null;
    form.hintEnabled = false;
    uploadSetState('idle');
    if (photoMount) photoMount.classList.remove('is-attached');
    if (photoToggle) {
      photoToggle.classList.remove('is-attached', 'is-open');
      photoToggle.setAttribute('aria-expanded', 'false');
    }
    if (photoBody) photoBody.hidden = true;
    gmResetThumb();
    gmHintOffKeepDraft();
    var reviewLine = root.querySelector('.gm-review-uploading');
    if (reviewLine && reviewLine.parentNode) reviewLine.parentNode.removeChild(reviewLine);
    dirty = true;
    renderPreview();
  }

  // One polite live region for upload milestones. The upload zone is a labelled button,
  // so text inside it is never read out.
  function gmAnnounce(text) {
    var el = root.querySelector('[data-gm-upload-announce]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-gm-upload-announce', '');
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;';
      root.appendChild(el);
    }
    el.textContent = '';
    setTimeout(function() { el.textContent = text; }, 50);
  }

  var GM_THUMB_ICON = '<svg viewBox="0 0 22 22" fill="none" stroke="currentColor" stroke-width="1.5" width="18" height="18" aria-hidden="true"><path d="M3.5 7.5h3l1.5-2h5l1.5 2h3a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-14A1.5 1.5 0 0 1 2 17V9a1.5 1.5 0 0 1 1.5-1.5z" /><circle cx="11" cy="13" r="3.2" /></svg>';
  var GM_VIDEO_ICON = '<svg viewBox="0 0 22 22" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" width="18" height="18" aria-hidden="true"><rect x="2.5" y="5" width="12.5" height="12" rx="2" /><path d="M15 9.5l4.5-2.5v8L15 12.5z" /></svg>';
  function gmResetThumb() {
    var thumb = root.querySelector('[data-gm-upload-thumb]');
    if (thumb) thumb.innerHTML = GM_THUMB_ICON;
  }

  // An upload that ends with no media (failed, cancelled, encode error) turns the
  // hint off so a phrase can never be committed without a photo or video to unlock.
  // The typed hint and answer stay in their fields for the retry.
  function gmHintOffKeepDraft() {
    if (form.attachmentURL) return;
    form.hintEnabled = false;
    var ht = root.querySelector('[data-gm-hint-toggle]');
    var hb = root.querySelector('[data-gm-hint-body]');
    if (ht) { ht.classList.remove('is-open', 'is-set'); ht.setAttribute('aria-expanded', 'false'); }
    if (hb) hb.hidden = true;
    syncHintAvailability(true);
    syncAddonOpenStateForStep1();
    if (typeof gmSyncHintStatus === 'function') gmSyncHintStatus();
  }

  function gmUploadJSON(url, options, attempt, timeout) {
    return new Promise(function(resolve, reject) {
      if (!gmUploadCurrent(attempt)) return reject(new Error('Upload cancelled.'));
      var controller = new AbortController();
      attempt.controllers.push(controller);
      var timer = gmUploadLater(attempt, function() {
        controller.abort();
        reject(new Error('Upload timed out. Check your connection and try again.'));
      }, timeout || 12000);
      fetch(url, Object.assign({}, options, { signal: controller.signal }))
        .then(function(r) {
          return r.json().catch(function(err) { if (r.ok) throw err; return {}; }).then(function(data) { return { ok: r.ok, status: r.status, data: data }; });
        })
        .then(function(result) { clearTimeout(timer); resolve(result); }, function(err) { clearTimeout(timer); reject(err); });
    });
  }

  function gmUploadTransfer(file, du, attempt, timeout) {
    return new Promise(function(resolve, reject) {
      if (!gmUploadCurrent(attempt)) return reject(new Error('Upload cancelled.'));
      var xhr = new XMLHttpRequest();
      attempt.xhrs.push(xhr);
      xhr.open('POST', du.uploadURL, true);
      xhr.timeout = timeout;
      var started = Date.now(), lastProgress = Date.now();
      // A slow uplink keeps sending; a dead one stops. 90s with no bytes moving = give up.
      var stall = setInterval(function() {
        if (!gmUploadCurrent(attempt) || attempt.finished) return clearInterval(stall);
        // reject before abort: abort() fires onabort synchronously, which would report "cancelled"
        if (Date.now() - lastProgress > 90000) { clearInterval(stall); reject(new Error('Upload timed out. Check your connection and try again.')); xhr.abort(); }
      }, 5000);
      xhr.addEventListener('loadend', function() { clearInterval(stall); });
      xhr.upload.onprogress = function(e) {
        lastProgress = Date.now();
        if (!gmUploadCurrent(attempt) || attempt.finished) return;
        if (!e.lengthComputable) return;
        var elapsed = (Date.now() - started) / 1000;
        var secs = (elapsed > 1.5 && e.loaded > 0) ? Math.round(elapsed * (e.total - e.loaded) / e.loaded) : -1;
        uploadSetProgress(e.loaded >= e.total ? 100 : Math.min(99, Math.round(e.loaded / e.total * 100)), secs);
      };
      xhr.onload = function() {
        if (!gmUploadCurrent(attempt)) return reject(new Error('Upload cancelled.'));
        var data = null; try { data = JSON.parse(xhr.responseText); } catch (_) {}
        if (xhr.status >= 200 && xhr.status < 300 && !(data && data.success === false)) resolve(du);
        else reject(new Error('The upload did not complete. Please try again.'));
      };
      xhr.onerror = function() { reject(new Error('Upload failed - check your connection.')); };
      xhr.ontimeout = function() { reject(new Error('Upload timed out. Check your connection and try again.')); };
      xhr.onabort = function() { reject(new Error('Upload cancelled.')); };
      var fd = new FormData(); fd.append('file', file, file.name || 'photo');
      xhr.send(fd);
    });
  }

  // ─── Public API ────────────────────────────────────────────────────────
  window.openGiftMessageModal = function() {
    // Duplicate callbacks must not erase the current draft or acquire another lock.
    if (root.getAttribute('data-open') === 'true') return;
    gmInvalidateUpload();
    gmWaitNote('');
    lastTrigger = document.activeElement;
    if (typeof window.closeCartDrawerV3 === 'function') window.closeCartDrawerV3();
    step = 1;
    done = {};
    dirty = false;
    mediaNudged = false;
    removeMediaNudge();

    // ── FULL STATE RESET ──────────────────────────────────────────────
    // Audit found: previously only notify state was reset between
    // sessions. Recipient name / relationship / occasion / tone / message
    // / photo / hint all persisted in both `form` AND the DOM after
    // closing the modal. A user who closed mid-flow and reopened would
    // see their previous draft - confusing UX + risk of accidentally
    // committing stale data. Now every form field + DOM input resets
    // to a clean slate on every open.
    form.first = '';
    form.last = '';
    form.rel = '';
    form.occ = '';
    form.tone = '';
    form.message = '';
    form.photoAttached = false;
    form.attachmentURL = '';
    form._uploadMeta = null;
    form.hintEnabled = false;
    form.hint = '';
    form.secretWord = '';
    form.emailUnlock = false;
    form.smsUnlock = false;
    form.email = '';
    form.phone = '';

    // Clear DOM inputs to match form state
    var inputs = root.querySelectorAll('[data-gm-input]');
    inputs.forEach(function(el) {
      if (el.tagName === 'SELECT') el.selectedIndex = 0;
      else el.value = '';
    });
    var limitStatus = root.querySelector('[data-gm-limit-status]');
    if (limitStatus) limitStatus.textContent = '';

    // Reset tone chip selection
    root.querySelectorAll('[data-gm-tone]').forEach(function(b) {
      b.classList.remove('is-active');
    });

    // Reset photo addon state - clear chip, idle dropzone, kill is-attached
    var photoMountEl = root.querySelector('[data-gm-photo-mount]');
    var photoToggleEl = root.querySelector('[data-gm-photo-toggle]');
    var photoBodyEl = root.querySelector('[data-gm-photo-body]');
    if (photoMountEl) photoMountEl.classList.remove('is-attached');
    if (photoToggleEl) {
      photoToggleEl.classList.remove('is-open', 'is-attached');
      photoToggleEl.setAttribute('aria-expanded', 'false');
    }
    if (photoBodyEl) photoBodyEl.hidden = true;
    // Reset thumb to default camera icon (was swapped to <img> on upload)
    var thumbReset = root.querySelector('[data-gm-upload-thumb]');
    if (thumbReset) {
      thumbReset.innerHTML = '<svg viewBox="0 0 22 22" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><path d="M3.5 7.5h3l1.5-2h5l1.5 2h3a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-14A1.5 1.5 0 0 1 2 17V9a1.5 1.5 0 0 1 1.5-1.5z" /><circle cx="11" cy="13" r="3.2" /></svg>';
    }
    // Reset upload state visuals to idle
    if (typeof uploadSetState === 'function') uploadSetState('idle');

    // Reset hint addon state
    var hintToggleEl = root.querySelector('[data-gm-hint-toggle]');
    var hintBodyEl = root.querySelector('[data-gm-hint-body]');
    if (hintToggleEl) {
      hintToggleEl.classList.remove('is-open');
      hintToggleEl.setAttribute('aria-expanded', 'false');
    }
    if (hintBodyEl) hintBodyEl.hidden = true;

    // Reset notify dropdown (closed + both channels off)
    var nt = root.querySelector('[data-gm-notify-toggle]');
    var nb = root.querySelector('[data-gm-notify-body]');
    if (nt) { nt.setAttribute('aria-expanded', 'false'); nt.classList.remove('is-open'); }
    if (nb) nb.hidden = true;

    // Reset character counter to 0
    if (typeof updateCounter === 'function') updateCounter();

    // Reset section-swap state on Step 1
    var step1 = root.querySelector('[data-gm-step="1"]');
    if (step1) step1.classList.remove('has-addon-open');
    syncCloseControlLabel();

    gmRelocateExtras();  // ensure addons are in the correct column for current viewport
    syncStep();
    if (typeof syncHintAvailability === 'function') syncHintAvailability();
    if (typeof syncUnlockRow === 'function') { syncUnlockRow('email'); syncUnlockRow('sms'); }
    setOpen(true);
  };

  window.closeGiftMessageModal = function(opts) {
    if (opts && opts.confirmIfDirty && dirty && !confirm('Discard your gift message?')) return;
    gmInvalidateUpload();
    gmWaitNote('');
    exitFocusMode();  // ensure focus mode resets between sessions
    // Backdrop/API dismissal does not move focus as an X-button tap does.
    // Release the field before hiding the dialog so its keyboard closes too.
    var active = document.activeElement;
    if (active && root.contains(active) && typeof active.blur === 'function') active.blur();
    setOpen(false);
    // Opened from the basket: go back to the basket. Focusing the trigger there
    // instead landed inside the CLOSED drawer and scrolled its stage, painting a
    // dead drawer on screen (Skip / Continue / X all ignored taps).
    var ctRoot = document.querySelector('.ct-root');
    if (lastTrigger && ctRoot && ctRoot.contains(lastTrigger) && typeof window.openCartDrawerV3 === 'function') {
      window.openCartDrawerV3();
    } else if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus({ preventScroll: true });
    }
  };

  // ─── Mobile focus mode (distraction-free writing) ──────────────────────
  // Tap the .gm-paper card on mobile → root gets .is-focus-mode. Form
  // chrome hides, card expands, Done button appears top-right. Exit via
  // Done button, swipe-down on card, or tap-outside the card. Same 280
  // char + 6 line caps as desktop (the JS rules above this section
  // already enforce - focus mode is purely visual).
  var gmFocusMQ = window.matchMedia('(max-width: 900px)');
  function isFocusEligible() { return gmFocusMQ.matches; }
  function shouldShowMediaReminders() { return !gmFocusMQ.matches; }

  // Safari keeps the CSS layout viewport taller than the space above its
  // keyboard. Fit the sheet to the actual visible viewport while a mobile
  // text field is active; otherwise leave the three-step layout alone.
  var gmViewportFrame = 0;
  var gmLastVisibleHeight = 0;
  var gmLastEditingField = null;
  function syncMobileViewport() {
    if (gmViewportFrame) cancelAnimationFrame(gmViewportFrame);
    gmViewportFrame = requestAnimationFrame(function() {
      gmViewportFrame = 0;
      var active = document.activeElement;
      var editing = isFocusEligible() && root.getAttribute('data-open') === 'true' &&
        active && root.contains(active) &&
        (active.tagName === 'TEXTAREA' ||
          (active.tagName === 'INPUT' && !/^(checkbox|radio|file|hidden|button|submit)$/i.test(active.type)));
      var writing = root.classList.contains('is-focus-mode');
      root.classList.toggle('is-editing-field', !!editing && !writing);
      if (!writing && !editing) {
        root.style.removeProperty('--gm-visible-height');
        root.style.removeProperty('--gm-visible-top');
        gmLastVisibleHeight = 0;
        gmLastEditingField = null;
        return;
      }
      var vv = window.visualViewport;
      var height = vv ? vv.height : window.innerHeight;
      var top = vv ? vv.offsetTop : 0;
      if (!height || !isFinite(height)) return;
      root.style.setProperty('--gm-visible-height', Math.round(height) + 'px');
      root.style.setProperty('--gm-visible-top', Math.round(top || 0) + 'px');
      // Reveal the active field when the keyboard reduces the available room.
      // Keep ordinary scrolling free while focus and viewport height stay put.
      if (editing && !writing && (active !== gmLastEditingField || height < gmLastVisibleHeight - 1)) {
        var body = root.querySelector('.gm-body');
        if (body) {
          var fieldBox = active.getBoundingClientRect();
          var bodyBox = body.getBoundingClientRect();
          // Keep the field's context together when it fits. Revealing only
          // the input can leave its label or accordion heading half visible.
          var context = active.closest('.gm-field, .gm-unlock-row');
          var revealTop = fieldBox.top;
          var room = bodyBox.height - 24;
          if (context && fieldBox.bottom - context.getBoundingClientRect().top <= room) {
            revealTop = context.getBoundingClientRect().top;
          }
          var panel = active.closest('.gm-addon-body');
          var heading = panel && panel.previousElementSibling;
          if (heading && heading.classList.contains('gm-addon') &&
              fieldBox.bottom - heading.getBoundingClientRect().top <= room) {
            revealTop = heading.getBoundingClientRect().top;
          }
          if (fieldBox.bottom > bodyBox.bottom - 12) body.scrollTop += fieldBox.bottom - bodyBox.bottom + 12;
          else if (revealTop < bodyBox.top + 12) body.scrollTop -= bodyBox.top + 12 - revealTop;
        }
      }
      gmLastVisibleHeight = height;
      gmLastEditingField = editing ? active : null;
    });
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', syncMobileViewport);
    window.visualViewport.addEventListener('scroll', syncMobileViewport);
  }
  window.addEventListener('resize', syncMobileViewport);
  window.addEventListener('orientationchange', syncMobileViewport);
  root.addEventListener('focusin', function() {
    // A field can regain focus after its panel was collapsed or scrolled.
    // Re-evaluate visibility even if both focus events land in one frame.
    gmLastEditingField = null;
    syncMobileViewport();
  });
  root.addEventListener('focusout', syncMobileViewport);

  // Mobile already presents the optional photo/video controls prominently.
  // If the viewport crosses into mobile while a desktop reminder is visible
  // (resize, rotation, split-screen), remove it immediately as well.
  function removeMediaNudgeOnMobile(e) {
    if (!e.matches) exitFocusMode();
    else removeMediaNudge();
    syncCloseControlLabel();
  }
  try { gmFocusMQ.addEventListener('change', removeMediaNudgeOnMobile); }
  catch (_) { try { gmFocusMQ.addListener(removeMediaNudgeOnMobile); } catch (__) {} }

  function enterFocusMode() {
    if (!isFocusEligible()) return;
    if (root.classList.contains('is-focus-mode')) return;
    if (step !== 1) return;  // only meaningful on Step 1 (the message step)
    var visibleError = root.querySelector('[data-gm-error]');
    if (visibleError) visibleError.hidden = true;
    root.classList.add('is-focus-mode');
    syncMobileViewport();
    // Auto-focus the textarea so the keyboard opens immediately
    requestAnimationFrame(function() {
      var ta = root.querySelector('[data-gm-input="message"]');
      if (ta && typeof ta.focus === 'function') {
        try { ta.focus(); } catch (_) {}
      }
    });
  }
  function exitFocusMode() {
    if (!root.classList.contains('is-focus-mode')) return;
    root.classList.remove('is-focus-mode');
    if (gmViewportFrame) cancelAnimationFrame(gmViewportFrame);
    gmViewportFrame = 0;
    root.style.removeProperty('--gm-visible-height');
    root.style.removeProperty('--gm-visible-top');
    var ta = root.querySelector('[data-gm-input="message"]');
    if (ta && typeof ta.blur === 'function') {
      try { ta.blur(); } catch (_) {}
    }
    syncMobileViewport();
  }

  // Tap the card editor to enter focus mode (mobile only). We listen on
  // the paper itself - clicks inside the textarea naturally fire here
  // via bubbling. Guard against re-entering if already in focus.
  var paperEl = root.querySelector('.gm-paper');
  if (paperEl) {
    paperEl.addEventListener('click', function(e) {
      if (root.classList.contains('is-focus-mode')) return;
      enterFocusMode();
    });
  }

  // Done button - primary exit
  var focusDoneBtn = root.querySelector('[data-gm-focus-done]');
  if (focusDoneBtn) {
    focusDoneBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      exitFocusMode();
    });
  }

  // Tap outside the card (anywhere in the body that isn't the paper) → exit
  var bodyEl = root.querySelector('.gm-body');
  if (bodyEl) {
    bodyEl.addEventListener('click', function(e) {
      if (!root.classList.contains('is-focus-mode')) return;
      if (e.target.closest('.gm-paper')) return;  // ignore clicks inside the card
      exitFocusMode();
    });
  }

  // Scrolling inside the note must not dismiss it. Done is the explicit exit.

  // Step changes (e.g. user taps Next) should auto-exit focus mode so
  // they don't carry the focus state into Delivery / Review.
  var __prevSetStepForFocus = setStep;
  setStep = function(n) {
    if (n !== 1) exitFocusMode();
    var result = __prevSetStepForFocus(n);
    syncCloseControlLabel();
    return result;
  };

  // ─── Open/close + a11y plumbing ────────────────────────────────────────
  // ANDROID CHROME BLACK-SQUARE FIX (2026-05-26 - round 3):
  // The cart drawer (.ct-root, z-9000) is fixed inset:0 and stays in the
  // DOM behind the gift modal even when its panel is slid translateX(100%)
  // off-screen. On Android Chrome that means it stays in the compositor
  // stack with its own GPU layer. When the native file picker dismisses,
  // the cart drawer's stale tiles can bleed through wherever the modal
  // panel's tiles haven't fully painted - producing the black squares.
  //
  // Fix: when the modal opens, fully display:none the cart drawer root.
  // It's invisible anyway (modal stacks above). When the modal closes,
  // restore. This removes the cart drawer from the compositor stack
  // entirely while the modal is up - no stale tiles to bleed through.
  function hideCartDrawerWhileModalOpen(hide) {
    var ctRoot = document.querySelector('.ct-root');
    if (!ctRoot) return;
    if (hide) {
      // Stash the original inline display value so we restore it cleanly.
      if (ctRoot.dataset.gmStashedDisplay === undefined) {
        ctRoot.dataset.gmStashedDisplay = ctRoot.style.display || '';
      }
      ctRoot.style.display = 'none';
    } else {
      ctRoot.style.display = ctRoot.dataset.gmStashedDisplay || '';
      delete ctRoot.dataset.gmStashedDisplay;
    }
  }

  function setOpen(open) {
    if (open === (root.getAttribute('data-open') === 'true')) return;
    var frameToken = ++openFrameToken;
    root.setAttribute('data-open', open ? 'true' : 'false');
    root.setAttribute('aria-hidden', open ? 'false' : 'true');
    root.toggleAttribute('inert', !open);
    syncMobileViewport();
    setBodyLock(open);
    setInertSiblings(open);
    hideCartDrawerWhileModalOpen(open);
    if (open) {
      // Wait one animation frame so the modal is paintable before we focus inside it
      requestAnimationFrame(function() {
        if (frameToken !== openFrameToken || root.getAttribute('data-open') !== 'true') return;
        var closeBtn = root.querySelector('.gm-close[data-gm-close]');
        if (closeBtn) closeBtn.focus({ preventScroll: true });
      });
    }
  }

  // Body scroll lock - ref-counted to play nice with cart-drawer-v3's lock.
  // Both surfaces share window.__ssBodyLockCount; last one to close
  // restores document overflow.
  function setBodyLock(lock) {
    if (lock === ownsBodyLock) return;
    ownsBodyLock = lock;
    var counter = window.__ssBodyLockCount || (window.__ssBodyLockCount = { n: 0 });
    if (lock) {
      counter.n++;
      document.documentElement.style.overflow = 'hidden';
    } else {
      counter.n = Math.max(0, counter.n - 1);
      if (counter.n === 0) document.documentElement.style.overflow = '';
    }
  }

  // Mark page content inert so AT users can't navigate behind the dialog
  // (WCAG SC 1.3.1 - aria-modal alone doesn't block focus in many AT).
  var inertSiblings = [];
  function setInertSiblings(inert) {
    if (!inert) {
      inertSiblings.forEach(function(child) { child.removeAttribute('inert'); });
      inertSiblings = [];
      return;
    }
    var children = document.body.children;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      if (child === root || child.contains(root)) continue;
      // Header stays active as an intentional escape hatch from the gift flow.
      if (child.id === 'header-group') continue;
      // Skip script/style nodes - they're harmless and not focusable
      if (child.tagName === 'SCRIPT' || child.tagName === 'STYLE') continue;
      if (!child.hasAttribute('inert')) {
        child.setAttribute('inert', '');
        inertSiblings.push(child);
      }
    }
  }

  function dismissGiftModalForHeaderNavigation() {
    exitFocusMode();
    setOpen(false);
    dirty = false;
  }

  document.addEventListener('click', function(e) {
    if (root.getAttribute('data-open') !== 'true') return;

    var logoLink = e.target.closest('#header-group a.header-logo, #header-group .header-logo a');
    if (logoLink) {
      e.preventDefault();
      dismissGiftModalForHeaderNavigation();
      window.location.assign(logoLink.getAttribute('href') || '/');
      return;
    }

    var menuTrigger = e.target.closest(
      '#header-group .header__menu-drawer-toggle, #header-group header-menu-drawer-toggle, #header-group summary[aria-controls*="drawer" i], #header-group summary[aria-controls*="menu" i]'
    );
    if (menuTrigger) {
      dismissGiftModalForHeaderNavigation();
    }
  }, true);

  // ─── Step machine ──────────────────────────────────────────────────────
  function syncStep() {
    // Write current step onto .gm-root so CSS can scope right-rail visibility
    // (input addons on Step 2 only; summary extras on Step 3+4). The
    // [data-gm-step="1"] node IS the user-facing Step 2 - see header comment.
    root.setAttribute('data-gm-current-step', String(step));

    root.querySelectorAll('[data-gm-step]').forEach(function(el) {
      el.classList.toggle('is-active', parseInt(el.getAttribute('data-gm-step'), 10) === step);
    });
    root.querySelectorAll('[data-gm-tab]').forEach(function(el) {
      var n = parseInt(el.getAttribute('data-gm-tab'), 10);
      el.classList.toggle('is-active', n === step);
      el.classList.toggle('is-done', !!done[n] && n !== step);
      el.disabled = n !== step && !done[n];
      if (n === step) el.setAttribute('aria-current', 'step');
      else el.removeAttribute('aria-current');
    });

    // Back / Next / Commit / Skip visibility.
    // Skip only shows on Step 2 (step === 1 internally - see header comment
    // on the data-gm-step="1" mapping); it's the only step where there's
    // an option to bypass without losing anything required downstream.
    var backBtn = root.querySelector('[data-gm-back]');
    var nextBtn = root.querySelector('[data-gm-next]');
    var commitBtn = root.querySelector('[data-gm-commit]');
    var skipBtnFoot = root.querySelector('[data-gm-skip]');
    if (backBtn) backBtn.hidden = (step === 1);
    if (nextBtn) nextBtn.hidden = (step === 3);
    if (commitBtn) commitBtn.hidden = (step !== 3);
    if (skipBtnFoot) skipBtnFoot.hidden = (step !== 1);

    // CTA label per step
    if (nextBtn) {
      if (step === 1) nextBtn.innerHTML = 'Next · Delivery <span aria-hidden="true">→</span>';
      else if (step === 2) nextBtn.innerHTML = 'Review <span aria-hidden="true">→</span>';
    }
  }

  // ─── Right-rail addons relocator ───────────────────────────────────────
  // The Step-2 input addons (.gm-extras-toggle + .gm-extras-wrap) live in
  // the left form column in source markup so mobile gets them in-flow.
  // On desktop, we move them into [data-gm-rA-extras-mount] in the right
  // rail so they sit in the user's eyeline next to the preview card -
  // no scroll required to discover photo + secret hint.
  //
  // Symmetric: on resize back to mobile, we move them back to the left
  // mount marker so the existing mobile section-swap pattern keeps working.
  var gmDesktopMQ = window.matchMedia('(min-width: 901px)');
  var extrasToggleEl = root.querySelector('[data-gm-extras-toggle]');
  var extrasWrapEl   = root.querySelector('[data-gm-extras-wrap]');
  var leftMountEl    = root.querySelector('[data-gm-extras-mobile-mount]');
  var rightMountEl   = root.querySelector('[data-gm-rA-extras-mount]');

  function gmRelocateExtras() {
    if (!extrasToggleEl || !extrasWrapEl) return;
    if (gmDesktopMQ.matches) {
      if (rightMountEl && extrasToggleEl.parentNode !== rightMountEl) {
        rightMountEl.appendChild(extrasToggleEl);
        rightMountEl.appendChild(extrasWrapEl);
        // On desktop, force the wrap open - no parent collapse needed
        // since both addons are now first-class right-rail cards.
        extrasWrapEl.removeAttribute('hidden');
        if (extrasToggleEl.setAttribute) extrasToggleEl.setAttribute('aria-expanded', 'true');
      }
    } else {
      if (leftMountEl && extrasToggleEl.parentNode !== leftMountEl.parentNode) {
        // Reinsert in source order: toggle then wrap, both directly after
        // the mobile mount marker.
        leftMountEl.parentNode.insertBefore(extrasToggleEl, leftMountEl.nextSibling);
        leftMountEl.parentNode.insertBefore(extrasWrapEl, extrasToggleEl.nextSibling);
        // Reset to mobile default: wrap collapsed, toggle reflects that
        // (mobile users expect to tap "Add a personal touch" to open).
        extrasWrapEl.setAttribute('hidden', '');
        if (extrasToggleEl.setAttribute) extrasToggleEl.setAttribute('aria-expanded', 'false');
      }
    }
  }
  // React to viewport changes (Safari + Chrome both support addEventListener)
  try { gmDesktopMQ.addEventListener('change', gmRelocateExtras); }
  catch (_) { try { gmDesktopMQ.addListener(gmRelocateExtras); } catch (__) {} }

  function setStep(n) {
    if (n < 1 || n > 3) return;
    removeMediaNudge();
    if (n !== step) {
      var active = document.activeElement;
      if (active && root.contains(active) && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName)) active.blur();
      var body = root.querySelector('.gm-body');
      if (body) body.scrollTop = 0;
    }
    step = n;
    syncStep();
    syncMobileViewport();
  }

  function advance() {
    if (!validateStep(step)) return;
    var error = root.querySelector('[data-gm-error]');
    if (error) error.hidden = true;
    // One-time, non-blocking media nudge: leaving the Message step with no
    // photo/video attached gently offers to add one. Fires at most once per
    // session; "Send words only" (or a second Next) advances. Never blocks.
    if (step === 1 && shouldShowMediaReminders() && !mediaNudged && !(form.attachmentURL && form.attachmentURL.length) && !gmUploadInFlight()) {
      mediaNudged = true;
      showMediaNudge();
      return;
    }
    done[step] = true;
    setStep(step + 1);
  }

  function removeMediaNudge() {
    if (nudgeEl && nudgeEl.parentNode) nudgeEl.parentNode.removeChild(nudgeEl);
    nudgeEl = null;
  }

  // Open the photo/video add-on and bring it into view (used by the nudge's
  // primary action). Clicks the existing toggle so all its wiring still runs.
  function openPhotoAddon() {
    var toggle = root.querySelector('[data-gm-photo-toggle]');
    var mount = root.querySelector('[data-gm-photo-mount]');
    if (toggle && toggle.getAttribute('aria-expanded') !== 'true') { try { toggle.click(); } catch (_) {} }
    var target = mount || toggle;
    if (target) { try { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_) {} }
  }

  // Gentle, brand-styled, in-canvas nudge appended to the bottom of the Message
  // step. Matches the cream/navy/terracotta system; soft fade-in, no popup.
  function showMediaNudge() {
    var step1 = root.querySelector('[data-gm-step="1"]');
    if (!step1 || nudgeEl) return;
    nudgeEl = document.createElement('div');
    nudgeEl.className = 'gm-media-nudge';
    nudgeEl.setAttribute('role', 'group');
    nudgeEl.setAttribute('aria-label', 'Add a photo or video');
    nudgeEl.style.cssText = 'margin:14px 0 2px;background:#fbf3ec;border:1px solid #ecd9c9;border-radius:12px;padding:15px 17px;display:flex;gap:13px;align-items:flex-start;opacity:0;transition:opacity .3s ease;';
    nudgeEl.innerHTML =
      '<div style="flex-shrink:0;width:32px;height:32px;border-radius:50%;background:#f3e2d6;display:flex;align-items:center;justify-content:center;">'
      + '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#a85e38" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg></div>'
      + '<div style="flex:1;min-width:0;">'
      + '<div style="font-family:\'Cormorant Garamond\',Georgia,serif;font-size:19px;color:#1A2A44;line-height:1.2;">One more thing - <em>add a little moment?</em></div>'
      + '<div style="font-size:13px;line-height:1.5;color:#6e6660;margin-top:3px;">A photo or short video is the part they keep, long after the box. It unlocks from the card&rsquo;s QR.</div>'
      + '<div style="display:flex;gap:10px;align-items:center;margin-top:12px;flex-wrap:wrap;">'
      + '<button type="button" data-gm-nudge-add style="background:#1A2A44;color:#fff;border:0;border-radius:999px;padding:9px 17px;font-size:13px;font-weight:500;cursor:pointer;">Add a photo or video</button>'
      + '<button type="button" data-gm-nudge-skip style="background:none;border:0;color:#8c8278;font-size:13px;cursor:pointer;text-decoration:underline;text-underline-offset:3px;">Send words only &rarr;</button>'
      + '</div></div>';
    step1.appendChild(nudgeEl);
    var addBtn = nudgeEl.querySelector('[data-gm-nudge-add]');
    var skipBtn = nudgeEl.querySelector('[data-gm-nudge-skip]');
    if (addBtn) addBtn.addEventListener('click', function() { removeMediaNudge(); openPhotoAddon(); });
    if (skipBtn) skipBtn.addEventListener('click', function() { removeMediaNudge(); advance(); });
    try { requestAnimationFrame(function() { if (nudgeEl) nudgeEl.style.opacity = '1'; }); } catch (_) { nudgeEl.style.opacity = '1'; }
    try { nudgeEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_) {}
  }

  function back() {
    setStep(step - 1);
  }

  // Validation - base rules. Per-step extensions chain via reassignment
  // (upload busy, hint fields, delivery email/sms).
  function validateStep(n) {
    if (n === 1) {
      if (!(form.first || '').trim()) {
        // CRITICAL: must show feedback. Pre-2026-05-23 this was a silent
        // `return false` and clicking "Next · Delivery" with no first
        // name appeared to do nothing - the bug user reported.
        showError('Add a first name - needed for the card greeting.');
        var firstInput = root.querySelector('[data-gm-input="first"]');
        if (firstInput && typeof firstInput.focus === 'function') {
          try { firstInput.focus(); } catch (_) {}
        }
        return false;
      }
    }
    return true;
  }

  // Wire back/next buttons
  var backBtn = root.querySelector('[data-gm-back]');
  var nextBtn = root.querySelector('[data-gm-next]');
  if (backBtn) backBtn.addEventListener('click', back);
  if (nextBtn) nextBtn.addEventListener('click', advance);

  // Tab clicks - only allow jumping to done steps OR current step
  root.querySelectorAll('[data-gm-tab]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var n = parseInt(btn.getAttribute('data-gm-tab'), 10);
      if (done[n] || n === step) {
        // Revisiting a completed tab must still validate fields edited since.
        for (var i = step; i < n; i++) if (!validateStep(i)) return;
        setStep(n);
      }
    });
  });

  // ─── Delegated input/change handler ────────────────────────────────────
  // Every field with data-gm-input="<key>" updates form state automatically.
  // B3/B6 just need to drop in markup; no per-field wiring required.
  //
  // PERF (audit 2026-05-26): coalesce renderPreview() calls to one per
  // animation frame. Previously every keystroke fired the full preview
  // re-render synchronously - for fast typists on a long message this
  // burned CPU and competed with the textarea repaint. rAF coalescing
  // means at most one preview render per frame regardless of how many
  // input events fire.
  var __gmPreviewRafId = 0;
  function schedulePreviewRender() {
    if (__gmPreviewRafId) return;  // already scheduled this frame
    __gmPreviewRafId = requestAnimationFrame(function() {
      __gmPreviewRafId = 0;
      if (typeof renderPreview === 'function') renderPreview();
    });
  }
  root.addEventListener('input', function(e) {
    var t = e.target;
    var key = t.getAttribute && t.getAttribute('data-gm-input');
    if (!key) return;
    if (t.type === 'checkbox') form[key] = t.checked;
    else form[key] = t.value;
    dirty = true;
    schedulePreviewRender();
  });
  root.addEventListener('change', function(e) {
    var t = e.target;
    var key = t.getAttribute && t.getAttribute('data-gm-input');
    if (!key) return;
    if (t.type === 'checkbox') form[key] = t.checked;
    else form[key] = t.value;
    dirty = true;
    schedulePreviewRender();
  });

  // ─── B8: renderPreview - physical-card preview + conditional extras ────
  function renderPreview() {
    gmSyncHintStatus();   // every path that switches the hint off ends in a preview refresh
    // Local escapeHtml fallback (the file-level one may not be hoisted in
    // all execution orders, so define safely here).
    var esc = (typeof escapeHtml === 'function')
      ? escapeHtml
      : function(s) {
          return String(s).replace(/[&<>"']/g, function(c) {
            return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
          });
        };

    var titleEl = root.querySelector('[data-gm-r-title]');
    if (titleEl) {
      var first = (form.first || '').trim();
      titleEl.textContent = (first ? first + '’s' : 'Their') + ' card';
    }

    // Desktop preview greet - auto-greet removed entirely. Users write
    // their own opener (Dear / Hey / whatever) into the textarea so the
    // card body reflects exactly what they typed, no second greeting line.
    var greetEl = root.querySelector('[data-gm-prev-greet]');
    if (greetEl) {
      greetEl.textContent = '';
      greetEl.hidden = true;
    }

    var bodyEl = root.querySelector('[data-gm-prev-body]');
    if (bodyEl) {
      if (form.message) {
        bodyEl.textContent = form.message;
        bodyEl.classList.remove('is-empty');
      } else {
        bodyEl.textContent = 'Your message will appear here as you type…';
        bodyEl.classList.add('is-empty');
      }
      // The top/bottom fade mask only makes sense when the letter is long
      // enough to scroll - otherwise it dims the first/last line of a short
      // message for no reason. Toggle it on actual overflow only.
      bodyEl.classList.toggle('is-scrollable', bodyEl.scrollHeight > bodyEl.clientHeight + 1);
    }

    // Notify extra
    var notifyEl = root.querySelector('[data-gm-extra-notify]');
    var channels = [];
    if (form.emailUnlock) channels.push('email');
    if (form.smsUnlock) channels.push('text');
    if (notifyEl) {
      if (channels.length) {
        notifyEl.hidden = false;
        var who = (form.first || 'them');
        // Use attachmentURL (truth source for "media attached") rather
        // than photoAttached (which only tracks the panel-open state).
        var hasMedia = !!(form.attachmentURL && form.attachmentURL.length);
        var inner = 'We’ll <strong>' + esc(channels.join(' & ')) + '</strong> '
                  + esc(who) + ' with a link - they can read your card'
                  + (hasMedia ? ' and watch your photo/video' : '')
                  + ' online too.';
        var t = root.querySelector('[data-gm-extra-notify-text]');
        if (t) t.innerHTML = inner;
      } else {
        notifyEl.hidden = true;
      }
    }

    // Photo extra - show only when media is actually attached
    // (form.attachmentURL set), not just when the panel is open.
    var photoExtra = root.querySelector('[data-gm-extra-photo]');
    if (photoExtra) photoExtra.hidden = !(form.attachmentURL && form.attachmentURL.length);

    // Hint extra - only show when the user has actually completed BOTH
    // sides of the hint mechanic (the hint they'll see + the secret word
    // they need to type). Pre-fix bug: this rendered the moment
    // form.hintEnabled flipped true (the user opening the hint addon),
    // so summaries appeared mid-fill with empty quotes ('Hint: "-" → …').
    var hintExtra = root.querySelector('[data-gm-extra-hint]');
    if (hintExtra) {
      var hintFilled = !!(form.hint && form.hint.trim());
      var secretFilled = !!(form.secretWord && form.secretWord.trim());
      var hintReady = form.hintEnabled && hintFilled && secretFilled;
      if (hintReady) {
        hintExtra.hidden = false;
        var ht = root.querySelector('[data-gm-extra-hint-text]');
        if (ht) ht.innerHTML = 'Hint: <strong>"' + esc(form.hint.trim()) + '"</strong> → they type your secret phrase to unlock the digital version.';
      } else {
        hintExtra.hidden = true;
      }
    }
  }

  // ─── Mobile inline preview (≤900px) ────────────────────────────────────
  // The new mobile design (handoff 2026-05-23) places card-chrome elements
  // INSIDE the .gm-paper container (Step 2) AND inside the postcard hero
  // (Step 4). Both reuse the same data-gm-mp-for / data-gm-mp-greet
  // selectors as the old mobile-preview block. We use querySelectorAll so
  // every instance updates in lockstep when the user types.
  var gmMobileMQ = window.matchMedia('(max-width: 900px)');
  function syncMobilePreview() {
    var isM = gmMobileMQ.matches;

    // Legacy mobile-preview block (now display:none on mobile via CSS,
    // but we still keep its hidden attr correct for any non-CSS lookers).
    var mp = root.querySelector('[data-gm-mobile-preview]');
    if (mp) mp.hidden = !isM;

    if (!isM) return;

    // "For X" - meta line, both in Step 2 card editor AND Step 4 postcard
    var forEls = root.querySelectorAll('[data-gm-mp-for]');
    var forTxt = form.first ? 'For ' + form.first : 'For them';
    forEls.forEach(function(el) { el.textContent = forTxt; });

    // "Dear X," - greeting. Empty when no first name (the :empty CSS
    // rule hides the element entirely so the card has no "Dear …,"
    // ghost text in the default state).
    // Mobile preview greet - same as desktop: no auto-greet, user writes
    // their own opener into the textarea.
    var greetEls = root.querySelectorAll('[data-gm-mp-greet]');
    greetEls.forEach(function(el) {
      el.textContent = '';
      el.classList.add('is-empty');
    });

    // Message body - only on legacy preview (Step 2 uses real textarea).
    var bodyEl = root.querySelector('[data-gm-mp-body]');
    if (bodyEl) {
      if (form.message) {
        bodyEl.textContent = form.message;
        bodyEl.classList.remove('is-empty');
      } else {
        bodyEl.textContent = 'Your message will appear here as you type…';
        bodyEl.classList.add('is-empty');
      }
    }

    // Show the complete message, including the writer's paragraph breaks.
    var rvBody = root.querySelector('[data-gm-rv-body]');
    if (rvBody) {
      if (form.message) {
        rvBody.textContent = form.message;
        rvBody.classList.remove('is-empty');
      } else {
        rvBody.textContent = 'Your card will be included blank.';
        rvBody.classList.add('is-empty');
      }
    }
  }

  // EDIT buttons on the Step 4 review recap rows - jump to the relevant
  // step. data-gm-edit-step holds the target step index (1=Message, 2=Delivery).
  root.addEventListener('click', function(e) {
    var btn = e.target.closest && e.target.closest('[data-gm-edit-step]');
    if (!btn) return;
    e.preventDefault();
    var target = parseInt(btn.getAttribute('data-gm-edit-step'), 10);
    if (target && typeof setStep === 'function') setStep(target);
  });
  // Listen for viewport changes
  if (gmMobileMQ.addEventListener) gmMobileMQ.addEventListener('change', syncMobilePreview);
  else if (gmMobileMQ.addListener) gmMobileMQ.addListener(syncMobilePreview);

  // Wire into renderPreview so mobile preview updates with every input
  var __origRenderPreviewForMobile = renderPreview;
  renderPreview = function() {
    __origRenderPreviewForMobile();
    syncMobilePreview();
  };
  // Initial sync
  syncMobilePreview();

  // ─── Close handlers ────────────────────────────────────────────────────
  var closeBtn = root.querySelector('.gm-close[data-gm-close]');
  function openMobileAddon() {
    return isFocusEligible() && step === 1
      ? root.querySelector('[data-gm-step="1"] .gm-addon.is-open') : null;
  }
  function syncCloseControlLabel() {
    if (closeBtn) closeBtn.setAttribute('aria-label', openMobileAddon() ? 'Back to message' : 'Exit gift message');
  }
  function closeOpenAddon() {
    var addon = openMobileAddon();
    if (!addon) return false;
    addon.click(); // existing toggle preserves the draft and upload state
    addon.focus({ preventScroll: true });
    return true;
  }
  function requestCloseFromControl() {
    if (!closeOpenAddon()) window.closeGiftMessageModal({ confirmIfDirty: true });
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      requestCloseFromControl();
    });
  }
  var backdrop = root.querySelector('[data-gm-backdrop]');
  if (backdrop) {
    backdrop.addEventListener('click', function() {
      window.closeGiftMessageModal({ confirmIfDirty: true });
    });
  }

  // Shared window-capture geometric net (ss-dismissible.js), same confirmIfDirty
  // semantics as the direct X handler above. The modal is z 12000 and sits under
  // the PDP swatch / print lightbox / detail sheet / homepage sheet, so those own
  // a tap that lands inside them.
  var GM_HIGHER_OVERLAY_SELECTOR = [
    '.c1-swv:not([hidden])',
    '.c1-pa-lb:not([hidden])',
    '.ss-detail-overlay.open',
    '#ss-detail-sheet[aria-hidden="false"]',
    '#ssfm-modal.is-open',
    '.search-modal__content[open]'
  ].join(',');
  if (window.ssRegisterDismissible) window.ssRegisterDismissible(root, '.gm-close[data-gm-close]', function () {
    requestCloseFromControl();
  }, {
    isOpen: function (r) { return r.getAttribute('data-open') === 'true'; },
    higherOverlays: GM_HIGHER_OVERLAY_SELECTOR
  });

  // ─── Tone chips → seed empty textarea ──────────────────────────────────
  var TONE_SEEDS = {
    'joyful':       'You make me laugh every time I think of you. Here\'s a little reminder of that.',
    'calm':         'Whenever the world gets loud, I hope this brings you a moment of quiet.',
    'celebratory':  'What a year you\'ve had. I\'m so proud of you - here\'s something to mark it.',
    'grateful':     'There aren\'t enough words for what you mean to me, but I\'ll try anyway.',
    'warm':         'Just because. No reason. Just thinking about you and wanting you to know.',
    'just-because': 'Saw this and thought of you. That\'s it. That\'s the message.'
  };

  root.querySelectorAll('[data-gm-tone]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var tone = btn.getAttribute('data-gm-tone');
      form.tone = tone;
      var ta = root.querySelector('[data-gm-input="message"]');
      // Seed only if textarea is empty or has very short content
      if (ta && (!ta.value.trim() || ta.value.trim().length < 20)) {
        ta.value = TONE_SEEDS[tone] || '';
        form.message = ta.value;
        updateCounter();
      }
      root.querySelectorAll('[data-gm-tone]').forEach(function(b) {
        b.classList.toggle('is-active', b === btn);
      });
      dirty = true;
      renderPreview();
    });
  });

  // ─── Photo/video upload (reuse Cloudflare Worker from gift-builder) ────
  var GM_WORKER_URL = 'https://same-skies-upload.same-skies.workers.dev';
  var GM_R2_TYPES = ['image/jpeg','image/png','image/gif','image/webp','video/mp4','video/quicktime','video/webm'];
  // Photos now go through Cloudflare Images, which accepts HEIC/HEIF/AVIF/TIFF and
  // converts. The R2 fallback still only takes the browser-renderable set above.
  var GM_ALLOWED = GM_R2_TYPES.concat(['image/heic','image/heif','image/avif','image/tiff']);
  var GM_MAX_IMAGE_BYTES = 10 * 1024 * 1024;   // Cloudflare Images per-file limit
  // Android Chrome reports '' for HEIC picked from the gallery; recover the type from the name.
  function gmFileType(file) {
    if (file.type && file.type !== 'application/octet-stream') return file.type;
    var n = (file.name || '').toLowerCase();
    if (/\.heic$/.test(n)) return 'image/heic';
    if (/\.heif$/.test(n)) return 'image/heif';
    if (/\.(jpe?g)$/.test(n)) return 'image/jpeg';
    if (/\.png$/.test(n)) return 'image/png';
    if (/\.(mov)$/.test(n)) return 'video/quicktime';
    if (/\.(mp4|m4v)$/.test(n)) return 'video/mp4';
    return '';
  }
  // Videos go straight to Stream, whose one-shot upload stops at 200 MiB (measured
  // 2026-10-06: 196.5 MiB accepted, 204.1 MiB refused); iPhone 4K runs ~170 MB a minute, so 100 MB
  // turned away most 4K clips over ~35s. The R2 fallback is still capped at the
  // Worker's MAX_BYTES (100 MB).
  var GM_MAX_BYTES = 209000000;   // just under Stream's 200 MiB cutoff, leaving room for the form envelope
  // Bigger clips (4K over ~70s) go up resumably instead (tus via the Worker's /stream/tus-upload).
  var GM_MAX_TUS_BYTES = 1024 * 1024 * 1024;
  var GM_TUS_CHUNK = 50 * 1024 * 1024;   // Stream wants chunks in multiples of 256 KiB
  var GM_MAX_R2_BYTES = 100 * 1024 * 1024;

  // 2026-10-06 upload speed: a phone photo (12-48 MP, 4-8 MB) is scaled in the
  // browser to the largest size we ever serve - the 2048px `full` variant used by
  // Save photo - so the sender uploads ~1 MB instead of the original. Decoded via
  // <img> because it honours EXIF orientation everywhere (createImageBitmap does
  // not on older Safari). Anything the browser can't decode (HEIC on Android
  // Chrome), that is already small, or that would not shrink goes up untouched.
  // Measured 2026-10-06 against Cloudflare's own resize of the original (24 MP iPhone,
  // 20 MP Sony): `full` scores higher SSIM than today, `card` is within 0.003 and
  // indistinguishable at 2x zoom. q0.95 over 0.92 because `full` is served as uploaded.
  var GM_PHOTO_EDGE = 2048;
  var GM_PHOTO_QUALITY = 0.95;
  var GM_PHOTO_KEEP_BYTES = 1.5 * 1024 * 1024;
  var GM_PHOTO_MAX_DECODE_BYTES = 25 * 1024 * 1024;   // a 100-200 MP original could exhaust a low-end in-app browser
  function gmPreparePhoto(file, ftype) {
    if (!/^image\/(jpeg|heic|heif|avif)$/.test(ftype) || file.size > GM_PHOTO_MAX_DECODE_BYTES || !window.URL || !URL.createObjectURL) return Promise.resolve(file);
    var src = URL.createObjectURL(file);
    var work = new Promise(function(resolve, reject) {
      var img = new Image();
      img.onload = function() { resolve(img); };
      img.onerror = reject;
      img.src = src;
    }).then(function(img) {
      var w0 = img.naturalWidth, h0 = img.naturalHeight;
      var scale = Math.min(1, GM_PHOTO_EDGE / Math.max(w0, h0));
      if (!w0 || !h0 || (scale === 1 && file.size <= GM_PHOTO_KEEP_BYTES)) return file;
      var w = Math.round(w0 * scale), h = Math.round(h0 * scale);
      var canvas = document.createElement('canvas');
      canvas.width = w; canvas.height = h;
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, w, h);   // flatten PNG transparency onto white, not black
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(img, 0, 0, w, h);
      return new Promise(function(resolve) { canvas.toBlob(resolve, 'image/jpeg', GM_PHOTO_QUALITY); }).then(function(blob) {
        canvas.width = canvas.height = 0;   // release the bitmap now; iOS caps total canvas memory
        if (!blob || blob.size >= file.size) return file;
        var name = (file.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg';
        try { return new File([blob], name, { type: 'image/jpeg', lastModified: file.lastModified }); }
        catch (_) { blob.name = name; return blob; }
      });
    });
    var timer;
    var timeout = new Promise(function(resolve) { timer = setTimeout(function() { resolve(file); }, 8000); });
    return Promise.race([work.catch(function() { return file; }), timeout])
      .then(function(out) { clearTimeout(timer); URL.revokeObjectURL(src); return out; });
  }

  // Local preview for the chip as soon as the photo is scaled, instead of waiting
  // for the upload to finish and the signed thumb to come back. Built from the
  // 2048px copy so a phone decodes the full original only once.
  function gmShowLocalThumb(file, attempt) {
    var thumbEl = root.querySelector('[data-gm-upload-thumb]');
    if (!thumbEl || !window.URL || !URL.createObjectURL) return;
    var img = document.createElement('img');
    img.alt = ''; img.width = 38; img.height = 38; img.decoding = 'async';
    img.style.objectFit = 'cover';
    img.setAttribute('data-gm-local', '');
    var src = URL.createObjectURL(file);
    img.onload = function() {   // HEIC on Android never loads, so the camera icon stays
      URL.revokeObjectURL(src);
      if (!gmUploadCurrent(attempt)) return;
      thumbEl.textContent = ''; thumbEl.appendChild(img);
    };
    img.onerror = function() { URL.revokeObjectURL(src); };
    img.src = src;
  }

  // "Add a personal touch" parent toggle - collapses photo + hint behind one CTA
  var extrasToggle = root.querySelector('[data-gm-extras-toggle]');
  var extrasWrap   = root.querySelector('[data-gm-extras-wrap]');
  if (extrasToggle && extrasWrap) {
    extrasToggle.addEventListener('click', function() {
      var open = extrasToggle.getAttribute('aria-expanded') === 'true';
      extrasToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      extrasWrap.hidden = open;
    });
  }

  var photoToggle = root.querySelector('[data-gm-photo-toggle]');
  var photoBody   = root.querySelector('[data-gm-photo-body]');
  var photoMount  = root.querySelector('[data-gm-photo-mount]');
  var uploadInput = root.querySelector('[data-gm-upload-input]');
  var uploadZone  = root.querySelector('[data-gm-upload-zone]');
  var photoBack   = root.querySelector('[data-gm-photo-back]');
  if (photoBack && photoToggle) {
    photoBack.addEventListener('click', function() {
      // Collapse only this panel. The gift message and any uploaded file stay.
      if (photoToggle.getAttribute('aria-expanded') === 'true') photoToggle.click();
      photoToggle.focus({ preventScroll: true });
    });
  }

  // MOBILE - when an addon opens, the step root gets `has-addon-open` so
  // the CSS can hide the recipient fields + card editor and let the addon
  // body fill the freed real estate (no scrolling required). Helper used by
  // both photo + hint toggle handlers below.
  // ───────────────────────────────────────────────────────────────────────
  // ANDROID CHROME BLACK-SQUARE - LIFELONG FIX (2026-05-31)
  // Root cause recap: on Samsung S24 / Android Chrome the native file picker
  // leaves STALE GPU compositor tiles in memory when it dismisses. Earlier
  // rounds (cart-drawer display:none + outline-offset flush) cleared them AT
  // PICKER-DISMISS time - but the tiles don't actually SURFACE until the next
  // big compositing pass inside the modal, which is the "section swap" when
  // the user opens the secret-hint addon (display:none's the form above and
  // reveals the hint body). No flush ran at THAT moment, so the squares came
  // back intermittently when choosing a hint after an upload.
  //
  // Fix: (1) flag that a picker was engaged this session; (2) run a robust,
  // position-safe tile-evict at EVERY section swap once a picker has been used
  // - which is exactly the surfacing moment. No-op until a picker runs, so
  // non-upload flows (and desktop/iOS) are untouched.
  //
  // Evict technique = group-opacity promote→depromote on .gm-root for one
  // frame. opacity:0.999 collapses the whole overlay subtree into a single
  // composited group layer; clearing it next frame de-promotes and forces
  // Android to repaint the region from scratch, discarding stale tiles.
  // .gm-root has NO opacity transition and 0.999 is visually imperceptible,
  // so there is zero flicker. We deliberately do NOT add translateZ to .gm -
  // it would override its translate(-50%, -50%) centering (see the
  // same-skies-android-compositor-trap memory). outline-offset on .gm is kept
  // as a belt-and-braces second dirty-marker (no outline is set, so the
  // offset change is also visually invisible).
  var __gmPickerEngaged = false;
  function gmEvictStaleTiles() {
    var gmPanel = root.querySelector('.gm');
    void root.offsetHeight;  // sync layout read → forces a genuine new pass
    root.style.opacity = '0.999';
    if (gmPanel) gmPanel.style.outlineOffset = '0.01px';
    requestAnimationFrame(function() {
      root.style.opacity = '';
      if (gmPanel) gmPanel.style.outlineOffset = '';
    });
  }

  function syncAddonOpenStateForStep1() {
    var step1 = root.querySelector('[data-gm-step="1"]');
    if (!step1) return;
    var anyOpen = !!step1.querySelector('.gm-addon.is-open');
    step1.classList.toggle('has-addon-open', anyOpen);
    syncCloseControlLabel();
    // Stale-tile SURFACING point: the section swap above triggers a large
    // compositing pass. If a native picker has run this session, evict any
    // stale Android tiles AFTER this layout settles (next frame) so the black
    // squares never get a chance to paint. No-op until a picker is engaged.
    if (__gmPickerEngaged) requestAnimationFrame(gmEvictStaleTiles);
  }

  // PROGRESSIVE DISCLOSURE - the secret hint card is the unlock for the
  // photo/video QR. Without a media attachment there's nothing for it to
  // unlock, so we dim the card + neuter interaction until media exists.
  // Called from the upload-success and clear handlers.
  function syncHintAvailability(preserveDraft) {
    var mount = root.querySelector('[data-gm-hint-mount-state]');
    if (!mount) return;
    var available = !!(form.attachmentURL && form.attachmentURL.length) || gmUploadInFlight();
    mount.classList.toggle('is-unavailable', !available);
    var hintControl = mount.querySelector('[data-gm-hint-toggle]');
    if (hintControl) hintControl.disabled = !available;

    // If we just transitioned to unavailable (user removed the photo)
    // and the hint had state, reset it so nothing leaks to the printer.
    if (!available && !preserveDraft) {
      if (form.hintEnabled || form.hint || form.secretWord) {
        form.hintEnabled = false;
        form.hint = '';
        form.secretWord = '';
        var hintInputEl = root.querySelector('[data-gm-input="hint"]');
        var secretInputEl = root.querySelector('[data-gm-input="secretWord"]');
        if (hintInputEl) hintInputEl.value = '';
        if (secretInputEl) secretInputEl.value = '';
        var hintToggleEl = root.querySelector('[data-gm-hint-toggle]');
        var hintBodyEl = root.querySelector('[data-gm-hint-body]');
        if (hintToggleEl) {
          hintToggleEl.classList.remove('is-open');
          hintToggleEl.setAttribute('aria-expanded', 'false');
        }
        if (hintBodyEl) hintBodyEl.hidden = true;
        syncAddonOpenStateForStep1();  // mobile section-swap state may need to recompute
      }
    }
  }

  if (photoToggle && photoBody && uploadInput && uploadZone) {
    photoToggle.addEventListener('click', function() {
      form.photoAttached = photoToggle.getAttribute('aria-expanded') !== 'true';
      photoBody.hidden = !form.photoAttached;
      photoToggle.setAttribute('aria-expanded', String(form.photoAttached));
      photoToggle.classList.toggle('is-open', form.photoAttached);
      syncAddonOpenStateForStep1();
      gmSyncAddonStatus();
      dirty = true;
      renderPreview();
    });

    // ANDROID CHROME BLACK-SQUARE FIX - the picker-dismiss + section-swap
    // evict now share one robust helper: gmEvictStaleTiles() (defined above,
    // alongside syncAddonOpenStateForStep1). Round 3's weaker outline-offset-
    // only flushModalCompositor() was superseded on 2026-05-31 because it ran
    // too early (at dismiss) and only marked tiles dirty without forcing a
    // full re-raster - letting squares resurface on the later hint section
    // swap. See the lifelong-fix comment block above for the full rationale.
    function armPickerDismissFlush() {
      // A picker is about to open - from now on, every section swap evicts
      // stale tiles (see gmEvictStaleTiles / syncAddonOpenStateForStep1).
      __gmPickerEngaged = true;
      var fired = false;
      function once() {
        if (fired) return;
        fired = true;
        window.removeEventListener('focus', once);
        document.removeEventListener('visibilitychange', onVis);
        // Picker dismissed → evict on next frame so any in-progress
        // picker-teardown paint completes first.
        requestAnimationFrame(gmEvictStaleTiles);
      }
      function onVis() { if (!document.hidden) once(); }
      window.addEventListener('focus', once, { once: true });
      document.addEventListener('visibilitychange', onVis);
      // Safety: if neither event fires within 60s, drop the listeners.
      setTimeout(function() {
        window.removeEventListener('focus', once);
        document.removeEventListener('visibilitychange', onVis);
      }, 60000);
    }

    uploadZone.addEventListener('click', function(e) {
      if (e.target.closest('[data-gm-upload-clear],[data-gm-upload-retry],[data-gm-upload-cancel]')) return;
      if (root.querySelector('[data-gm-upload-state="done"]:not([hidden]),[data-gm-upload-state="busy"]:not([hidden])')) return;
      armPickerDismissFlush();
      uploadInput.click();
    });

    // Keyboard activation on zone
    uploadZone.addEventListener('keydown', function(e) {
      if (e.target !== uploadZone) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        armPickerDismissFlush();
        uploadInput.click();
      }
    });

    uploadInput.addEventListener('change', function() {
      var file = uploadInput.files && uploadInput.files[0];
      if (!file) return;
      uploadInput.value = ''; // reset so same file can be re-selected after removal
      uploadFile(file);
    });

    root.querySelectorAll('[data-gm-upload-clear]').forEach(function(clearBtn) {
      clearBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        gmClearUpload();
      });
    });

    var cancelBtn = root.querySelector('[data-gm-upload-cancel]');
    if (cancelBtn) cancelBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      gmClearUpload();
    });

    var retryBtn = root.querySelector('[data-gm-upload-retry]');
    if (retryBtn) {
      retryBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        gmInvalidateUpload();
        uploadSetState('idle');
        var retryToken = gmUploadToken;
        setTimeout(function() {
          if (retryToken !== gmUploadToken || root.getAttribute('data-open') !== 'true') return;
          armPickerDismissFlush();
          uploadInput.click();
        }, 50);
      });
    }
  }

  // Busy row = "Uploading… 45%" + Cancel, then a quiet second line with the estimate
  // and the keep-going reassurance. The note waits 3s so a quick photo never flashes it,
  // and by then the estimate is usually in, so the row grows once rather than twice.
  var gmProgress = { pct: 0, secs: -1 };
  var gmNoteTimer = null;
  var GM_KEEP_GOING = 'Carry on with the rest\u00a0- it uploads in the background. Just don\u2019t close this tab.';
  function uploadSetState(state) {
    root.querySelectorAll('[data-gm-upload-state]').forEach(function(el) {
      el.hidden = el.getAttribute('data-gm-upload-state') !== state;
    });
    var busy = root.querySelector('[data-gm-upload-state="busy"]');
    var note = busy && busy.querySelector('[data-gm-upload-keepgoing]');
    if (busy && !note) {
      note = document.createElement('p');
      note.className = 'gm-upload-note';
      note.setAttribute('data-gm-upload-keepgoing', '');
      busy.appendChild(note);
    }
    clearTimeout(gmNoteTimer);
    if (note) note.hidden = true;
    if (state === 'busy') {
      gmProgress = { pct: 0, secs: -1 };
      gmAnnounce('Uploading your photo or video. You can keep going.');
      if (note) note.textContent = GM_KEEP_GOING;
      gmNoteTimer = setTimeout(function() { if (note && gmUploadInFlight()) note.hidden = false; }, 3000);
    }
    gmSyncAddonStatus();
  }

  function gmSecondsLeft(secs) {
    if (secs < 0) return '';
    if (secs < 8) return 'A few seconds left. ';
    if (secs < 53) return 'About ' + (Math.round(secs / 5) * 5) + ' seconds left. ';
    var mins = Math.round(secs / 60);
    return mins <= 1 ? 'About a minute left. ' : 'About ' + mins + ' minutes left. ';
  }

  function uploadSetProgress(pct, secs) {
    gmProgress = { pct: pct, secs: secs };
    uploadSetBusyText(pct >= 100 ? 'Almost there\u2026' : 'Uploading\u2026 ' + pct + '%');
    var note = root.querySelector('[data-gm-upload-keepgoing]');
    if (note) note.textContent = (pct >= 100 ? '' : gmSecondsLeft(secs)) + GM_KEEP_GOING;
    gmSyncAddonStatus();
  }

  // With the media panel collapsed mid-upload, the card itself carries the progress.
  function gmSyncAddonStatus() {
    if (!photoToggle) return;
    var el = photoToggle.querySelector('[data-gm-addon-status]');
    var failed = !!root.querySelector('[data-gm-upload-state="err"]:not([hidden])');
    var show = (gmUploadInFlight() || failed) && photoToggle.getAttribute('aria-expanded') !== 'true';
    if (!el && !show) return;
    if (!el) {
      var main = photoToggle.querySelector('.gm-addon-main') || photoToggle;
      el = document.createElement('span');
      el.className = 'gm-addon-status';
      el.setAttribute('data-gm-addon-status', '');
      main.appendChild(el);
    }
    var span = root.querySelector('[data-gm-upload-progress]');
    el.textContent = failed ? 'Didn\u2019t upload - open to try again' : (span ? span.textContent : 'Uploading\u2026');
    el.hidden = !show;
  }

  function uploadSetBusyText(text) {
    var busy = root.querySelector('[data-gm-upload-state="busy"]');
    var span = busy ? busy.querySelector('[data-gm-upload-progress]') : null;
    if (span) span.textContent = text;
  }

  // Shared tail for both upload paths: stamp the URL, show the chip, run the
  // staged layout cascade (see the GLITCH FIX note in uploadFileToR2).
  function uploadFinished(file, url, meta, attempt) {
    if (!gmUploadCurrent(attempt)) return;
    attempt.finished = true;
    attempt.timers.forEach(clearTimeout);
    form.attachmentURL = url;
    form._uploadMeta = {
      shortId:        (meta && meta.shortId) || null,
      key:            (meta && meta.key) || null,
      streamUid:      (meta && meta.streamUid) || null,
      imagesId:       (meta && meta.imagesId) || null,
      hintAtUpload:   (form.hint || '').trim(),
      secretAtUpload: (form.secretWord || '').trim().toLowerCase(),
    };
    var nameEl = root.querySelector('[data-gm-upload-name]');
    if (nameEl) nameEl.textContent = file.name;
    uploadSetState('done');
    gmAnnounce('Your photo or video is attached.');
    dirty = true;
    requestAnimationFrame(function() {
      if (!gmUploadCurrent(attempt)) return;
      requestAnimationFrame(function() {
        if (!gmUploadCurrent(attempt)) return;
        syncHintAvailability();
        if (photoToggle && photoToggle.classList.contains('is-open')) {
          photoToggle.classList.remove('is-open');
          photoToggle.classList.add('is-attached');
          if (photoMount) photoMount.classList.add('is-attached');
          photoToggle.setAttribute('aria-expanded', 'false');
          if (photoBody) photoBody.hidden = false;
          syncAddonOpenStateForStep1();
        } else if (photoToggle) {
          // Sender collapsed the panel (or left the step) mid-upload: still show it attached.
          photoToggle.classList.add('is-attached');
          if (photoMount) photoMount.classList.add('is-attached');
          if (photoBody) photoBody.hidden = false;
        }
        var reviewHint = root.querySelector('.gm-review-uploading');
        if (reviewHint) reviewHint.textContent = form._uploadMeta && form._uploadMeta.streamUid ? GM_VIDEO_UPLOADED_NOTE : 'Your photo or video is attached.';
        renderPreview();
        __gmPickerEngaged = true;
        gmEvictStaleTiles();
      });
    });
  }

  function uploadShowError(text) {
    var el = root.querySelector('[data-gm-upload-err-msg]');
    if (el) el.textContent = text;
    var retryBtn = root.querySelector('[data-gm-upload-retry]');
    if (retryBtn) retryBtn.textContent = /over 3 minutes|over 1 GB|over 10 MB|isn.t supported|not supported|could not be processed|too large|format needs/i.test(text || '') ? 'Choose another' : 'Try again';
    uploadSetState('err');
  }

  // Video path (2026-09-12): mint a Stream direct-upload URL from the Worker, POST
  // the file straight to Stream with real progress. The stored media URL is the HLS
  // manifest; the reveal page plays it natively on Safari and through hls.js
  // elsewhere, and offers an MP4 to save. `fallback` runs the old R2 upload if
  // Stream is not configured yet.
  //
  // 2026-10-06 upload speed: the sender no longer waits for Stream to encode
  // (about 0.6x the clip length - 18s for a 30s clip). The HLS URL is known at
  // mint, and the recipient opens the gift days later, so the chip goes to
  // "attached" as soon as the bytes land. The ready webhook requests the Save-video
  // MP4 even after the sender leaves. Background polls also catch an encode failure
  // while the modal is still open and put the chip back into its error state.
  // The 3-minute cap is checked from the file's own metadata alongside the upload,
  // so a long clip stops within a second instead of failing after the whole upload.
  var GM_MAX_VIDEO_SECONDS = 180;   // matches maxDurationSeconds on the Worker's Stream mint
  function gmVideoDuration(file) {
    return new Promise(function(resolve) {
      if (!window.URL || !URL.createObjectURL) return resolve(0);
      var v = document.createElement('video');
      var src = URL.createObjectURL(file);
      var settled = false;
      function done(d) {
        if (settled) return; settled = true;
        v.removeAttribute('src'); try { v.load(); } catch (_) {}
        URL.revokeObjectURL(src);
        resolve(isFinite(d) && d > 0 ? d : 0);
      }
      v.preload = 'metadata'; v.muted = true;
      v.onloadedmetadata = function() { done(v.duration); };
      v.onerror = function() { done(0); };   // HEVC on desktop Chrome etc.: unknown, let Stream decide
      setTimeout(function() { done(0); }, 4000);
      v.src = src;
    });
  }

  var gmStreamReady = {};
  var GM_VIDEO_UPLOADED_NOTE = 'Your video\u2019s uploaded. We\u2019ll finish preparing it while you carry on.';
  function gmWatchStreamEncode(uid, attempt) {
    var deadline = Date.now() + 15 * 60 * 1000;
    function poll() {
      if (attempt.cancelled || Date.now() >= deadline) return;
      fetch(GM_WORKER_URL + '/stream/status/' + uid, { cache: 'no-store' })
        .then(function(r) { if (r.status === 404) return { gone: true }; return r.ok ? r.json().catch(function() { return null; }) : null; })
        .then(function(st) {
          if (attempt.cancelled) return;
          if (st && st.gone) return;
          if (st && st.ready) { gmStreamReady[uid] = true; return; }   // the Worker requested the MP4 rendition on this poll
          if (st && st.state === 'error') {
            if (!gmUploadCurrent(attempt)) return;
            var cb = root.querySelector('[data-gm-commit]');
            if (cb && cb.getAttribute('aria-disabled') === 'true') return;   // commit already under way: its own status check decides
            form.attachmentURL = '';
            form._uploadMeta = null;
            gmUploadFail(attempt, /DURATION/i.test(st.errorCode || '') ? 'That video is over 3 minutes. Trim it a little and try again.' : 'That video could not be processed. Try a different clip.');
            renderPreview();
            return;
          }
          setTimeout(poll, 4000);
        }, function() { setTimeout(poll, 6000); });
    }
    setTimeout(poll, 2000);
  }

  // Resumable upload for big clips (tus 1.0): 50 MiB chunks straight to Stream. A dropped
  // connection asks Stream how much it already has (HEAD) and carries on from there, up to
  // six times, instead of starting a 300 MB upload again. A chunk with no bytes moving for
  // 90s counts as a drop.
  function gmTusTransfer(file, uploadURL, attempt) {
    return new Promise(function(resolve, reject) {
      var offset = 0, tries = 0, started = Date.now(), startOffset = 0;
      function send() {
        if (!gmUploadCurrent(attempt)) return reject(new Error('Upload cancelled.'));
        if (offset >= file.size) return resolve();
        var end = Math.min(file.size, offset + GM_TUS_CHUNK);
        var xhr = new XMLHttpRequest();
        attempt.xhrs.push(xhr);
        var lastProgress = Date.now(), settled = false;
        var stall = setInterval(function() {
          if (settled || !gmUploadCurrent(attempt)) return clearInterval(stall);
          if (Date.now() - lastProgress > 90000) { settled = true; clearInterval(stall); xhr.abort(); retry(); }
        }, 5000);
        xhr.open('PATCH', uploadURL, true);
        xhr.setRequestHeader('Tus-Resumable', '1.0.0');
        xhr.setRequestHeader('Upload-Offset', String(offset));
        xhr.setRequestHeader('Content-Type', 'application/offset+octet-stream');
        xhr.upload.onprogress = function(e) {
          lastProgress = Date.now();
          if (!gmUploadCurrent(attempt) || attempt.finished) return;
          var sent = offset + (e.loaded || 0);
          var elapsed = (Date.now() - started) / 1000, moved = sent - startOffset;
          var secs = (elapsed > 1.5 && moved > 0) ? Math.round(elapsed * (file.size - sent) / moved) : -1;
          uploadSetProgress(sent >= file.size ? 100 : Math.min(99, Math.round(sent / file.size * 100)), secs);
        };
        xhr.onload = function() {
          if (settled) return;
          settled = true; clearInterval(stall);
          if (xhr.status === 204 || xhr.status === 200) {
            var o = parseInt(xhr.getResponseHeader('Upload-Offset'), 10);
            offset = isFinite(o) ? o : end;
            tries = 0;
            send();
          } else if (xhr.status === 409 || xhr.status === 423 || xhr.status >= 500) {
            retry();   // offset mismatch or a busy server: ask where it got to
          } else {
            reject(new Error('The upload did not complete. Please try again.'));
          }
        };
        xhr.onerror = function() { if (settled) return; settled = true; clearInterval(stall); retry(); };
        xhr.onabort = function() { if (settled) return; settled = true; clearInterval(stall); reject(new Error('Upload cancelled.')); };
        xhr.send(file.slice(offset, end));
      }
      function freshBudget() { if (document.visibilityState !== 'hidden') tries = Math.min(tries, 1); }
      document.addEventListener('visibilitychange', freshBudget);
      window.addEventListener('online', freshBudget);
      var done = function(fn) { return function(v) { document.removeEventListener('visibilitychange', freshBudget); window.removeEventListener('online', freshBudget); fn(v); }; };
      resolve = done(resolve); reject = done(reject);
      function retry() {
        if (!gmUploadCurrent(attempt)) return reject(new Error('Upload cancelled.'));
        if (++tries > 6) return reject(new Error('Upload failed - check your connection and try again.'));
        uploadSetBusyText('Reconnecting\u2026');
        var rcNote = root.querySelector('[data-gm-upload-keepgoing]');
        if (rcNote) rcNote.textContent = GM_KEEP_GOING;
        gmSyncAddonStatus();
        var waited = setTimeout(function() { if (!gmUploadCurrent(attempt)) reject(new Error('Upload cancelled.')); }, Math.min(30000, 2000 * tries) + 50);
        attempt.timers.push(waited);
        gmUploadLater(attempt, function() {
          var h = new XMLHttpRequest();
          attempt.xhrs.push(h);
          h.open('HEAD', uploadURL, true);
          h.setRequestHeader('Tus-Resumable', '1.0.0');
          h.timeout = 20000;
          h.onload = function() {
            var o = parseInt(h.getResponseHeader('Upload-Offset'), 10);
            if ((h.status === 200 || h.status === 204) && isFinite(o)) { offset = o; startOffset = o; started = Date.now(); send(); }
            else retry();
          };
          h.onerror = h.ontimeout = function() { retry(); };
          h.onabort = function() { reject(new Error('Upload cancelled.')); };
          h.send();
        }, Math.min(30000, 2000 * tries));
      }
      send();
    });
  }

  var gmVideoPrepareAsset = 'ss-video-prepare-5de10ea31a45.js';
  var gmVideoScript = document.currentScript || Array.prototype.find.call(document.scripts, function(s) { return /gift-message-modal\.js/.test(s.src || ''); });
  var gmVideoWorkerURL = gmVideoScript && gmVideoScript.src ? new URL(gmVideoPrepareAsset, gmVideoScript.src).href : '';
  var gmVideoUplink = null;

  // Measure only a small blank payload, never the customer's video. The optional check is bounded.
  function gmVideoUploadRate(attempt) {
    if (gmVideoUplink && Date.now() - gmVideoUplink.at < 60000) return Promise.resolve(gmVideoUplink.rate);
    function request(method, url, body, timeout) {
      return new Promise(function(resolve) {
        var xhr = new XMLHttpRequest(), began = performance.now();
        attempt.xhrs.push(xhr); xhr.open(method, url, true); xhr.timeout = timeout;
        if (method === 'POST') xhr.setRequestHeader('Content-Type', 'text/plain');
        xhr.onload = function() { resolve({ ok: xhr.status >= 200 && xhr.status < 300, ms: performance.now() - began }); };
        xhr.onerror = xhr.onabort = function() { resolve(null); };
        xhr.ontimeout = function() { resolve({ timeout: true, ms: performance.now() - began }); };
        xhr.send(body);
      });
    }
    return request('GET', 'https://speed.cloudflare.com/__down?bytes=0&ss=' + Date.now(), null, 1000).then(function(ping) {
      if (!gmUploadCurrent(attempt) || !ping || !ping.ok) return null;
      var bytes = 512 * 1024;
      return request('POST', 'https://speed.cloudflare.com/__up', new Uint8Array(bytes), 1500).then(function(sent) {
        if (!gmUploadCurrent(attempt) || !sent || (!sent.ok && !sent.timeout)) return null;
        var rate = bytes * 1000 / Math.max(50, sent.ms - ping.ms);
        if (!sent.timeout) gmVideoUplink = { rate: rate, at: Date.now() };
        return rate;
      });
    });
  }

  function gmPrepareVideo(file, attempt) {
    if (file.size < 64 * 1024 * 1024 || !gmVideoWorkerURL || !window.Worker || !window.VideoEncoder || !window.VideoDecoder || !window.URL || !URL.createObjectURL) return Promise.resolve(file);
    return new Promise(function(resolve) {
      var worker, objectURL, timer, settled = false, preparing = false;
      attempt.preparing = true;
      uploadSetState('busy'); uploadSetBusyText('Preparing video\u2026');
      function finish(prepared) {
        if (settled) return; settled = true; clearTimeout(timer);
        if (worker) worker.terminate();
        if (objectURL) URL.revokeObjectURL(objectURL);
        attempt.preparing = false;
        resolve(prepared);
      }
      function deadline(ms) {
        clearTimeout(timer);
        timer = setTimeout(function() { finish(file); }, ms);
        attempt.timers.push(timer);
      }
      attempt.cleanups = attempt.cleanups || [];
      attempt.cleanups.push(function() { finish(null); });
      try {
        objectURL = URL.createObjectURL(new Blob(['importScripts(' + JSON.stringify(gmVideoWorkerURL) + ');'], { type: 'application/javascript' }));
        worker = new Worker(objectURL);
        deadline(8000);
        worker.onerror = function() { finish(file); };
        worker.onmessage = function(event) {
          if (!gmUploadCurrent(attempt)) { finish(null); return; }
          var data = event.data || {};
          if (data.kind === 'original') { finish(file); return; }
          if (data.kind === 'too-long') { finish(null); gmUploadFail(attempt, 'That video is over 3 minutes. Trim it a little and try again.'); return; }
          if (data.kind === 'inspected' && !preparing) {
            preparing = true;
            gmVideoUploadRate(attempt).then(function(rate) {
              if (settled || !gmUploadCurrent(attempt)) return;
              if (!rate || rate >= 50 * 1000 * 1000 / 8) { finish(file); return; }
              var savingMs = (file.size - data.estimatedBytes) / rate * 1000;
              var budget = Math.min(90000, Math.max(4000, savingMs * 0.72));
              deadline(budget + 500);
              worker.postMessage({ kind: 'prepare', budgetMs: budget });
            }, function() { finish(file); });
          } else if (data.kind === 'progress') {
            gmProgress = { pct: 0, secs: data.secs };
            uploadSetBusyText('Preparing video\u2026 ' + data.pct + '%');
            gmSyncAddonStatus();
          } else if (data.kind === 'prepared') {
            if (!data.blob || !data.blob.size || data.blob.size >= file.size * 0.80) { finish(file); return; }
            try {
              var name = (file.name || 'video').replace(/\.[^.]+$/, '') + '.mp4';
              finish(new File([data.blob], name, { type: 'video/mp4', lastModified: file.lastModified || Date.now() }));
            } catch (_) { finish(file); }
          }
        };
        worker.postMessage({ kind: 'inspect', file: file });
      } catch (_) { finish(file); }
    });
  }

  function uploadVideoViaStream(file, fallback, attempt) {
    var big = !!attempt.resumable || file.size > GM_MAX_BYTES;
    uploadSetState('busy');
    uploadSetBusyText('Preparing\u2026');
    var duration = gmVideoDuration(file);
    duration.then(function(seconds) {
      if (seconds > GM_MAX_VIDEO_SECONDS) gmUploadFail(attempt, 'That video is over 3 minutes. Trim it a little and try again.');   // aborts the transfer
    });
    // Start the upload address request alongside metadata. A duration rejection
    // cancels this attempt, including a pending address request or active transfer.
    var mint = big
      ? gmUploadJSON(GM_WORKER_URL + '/stream/tus-upload', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ size: file.size, name: file.name || 'video' }) }, attempt)
      : gmUploadJSON(GM_WORKER_URL + '/stream/direct-upload', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' }, attempt);
    mint
      .then(function(r) {
        if (!gmUploadCurrent(attempt)) throw new Error('Upload cancelled.');
        if (r.status === 429) throw new Error((r.data && r.data.error) || 'Too many uploads. Please wait a minute.');
        if (!r.ok) {
          if (big) throw new Error('We couldn\u2019t start that upload. Please try again in a moment.');   // too big for the fallback
          throw { fallback: true };
        }
        if (!r.data || !r.data.uploadURL || !r.data.uid || !r.data.hls) throw new Error('Could not start the upload.');
        if (big) return gmTusTransfer(file, r.data.uploadURL, attempt).then(function() { return r.data; });
        return gmUploadTransfer(file, r.data, attempt, gmVideoTransferMs(file));
      })
      .then(function(du) {
        if (!gmUploadCurrent(attempt)) return;
        var vt = root.querySelector('[data-gm-upload-thumb]');
        if (vt) vt.innerHTML = GM_VIDEO_ICON;
        uploadFinished(file, du.hls, { streamUid: du.uid }, attempt);
        gmWatchStreamEncode(du.uid, attempt);
      })
      .catch(function(err) {
        if (!gmUploadCurrent(attempt)) return;
        if (err && err.fallback && typeof fallback === 'function') { fallback(); return; }
        gmUploadFail(attempt, (err && err.message) ? String(err.message).slice(0, 200) : 'Upload failed - check your connection.');
      });
  }

  // `fallback` receives the prepared (scaled) file so the R2 path also sends the small one.
  function uploadImageViaImages(file, fallback, attempt) {
    uploadSetState('busy');
    uploadSetBusyText('Uploading\u2026');
    // The upload-URL mint (~0.4s) and the in-browser scale run side by side.
    var mint = gmUploadJSON(GM_WORKER_URL + '/images/direct-upload', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' }, attempt);
    var prepared = gmPreparePhoto(file, gmFileType(file));
    mint.catch(function() {});
    prepared
      .then(function(small) {
        if (!gmUploadCurrent(attempt)) throw new Error('Upload cancelled.');
        if (small.size > GM_MAX_IMAGE_BYTES) throw new Error('That photo is over 10 MB. Choose a smaller image and try again.');
        if (small !== file || small.size <= GM_PHOTO_KEEP_BYTES) gmShowLocalThumb(small, attempt);
        file = small;
        return mint;
      })
      .then(function(r) {
        if (!gmUploadCurrent(attempt)) throw new Error('Upload cancelled.');
        if (r.status === 429) throw new Error((r.data && r.data.error) || 'Too many uploads. Please wait a minute.');
        if (!r.ok) throw { fallback: true };
        if (!r.data || !r.data.uploadURL || !r.data.url) throw new Error('Could not start the upload.');
        return gmUploadTransfer(file, r.data, attempt, 3 * 60 * 1000);
      })
      .then(function(du) {
        if (!gmUploadCurrent(attempt)) return;
        var thumbEl = root.querySelector('[data-gm-upload-thumb]');
        if (thumbEl && du.thumb && !thumbEl.querySelector('img[data-gm-local]')) {
          thumbEl.textContent = '';
          var img = document.createElement('img');
          img.src = du.thumb; img.alt = ''; img.width = 38; img.height = 38; img.decoding = 'async';
          thumbEl.appendChild(img);
        }
        uploadFinished(file, du.url, { imagesId: du.id }, attempt);
      })
      .catch(function(err) {
        if (!gmUploadCurrent(attempt)) return;
        if (err && err.fallback && typeof fallback === 'function') { fallback(file); return; }
        gmUploadFail(attempt, (err && err.message) ? String(err.message).slice(0, 200) : 'Upload failed - check your connection.');
      });
  }

  function uploadFile(file) {
    var attempt = gmBeginUpload(file);
    var ftype = gmFileType(file);
    if (GM_ALLOWED.indexOf(ftype) === -1) {
      var errMsg = root.querySelector('[data-gm-upload-err-msg]');
      if (errMsg) errMsg.textContent = 'That file type isn\u2019t supported. Try a photo from your camera roll, or an MP4 or MOV video.';
      gmUploadFail(attempt, errMsg ? errMsg.textContent : 'That file type is not supported.');
      return;
    }
    // Images path checks its 10 MB cap after scaling (a 48 MP photo shrinks well under it).
    if (ftype === 'image/gif' && file.size > GM_MAX_IMAGE_BYTES) {
      gmUploadFail(attempt, 'That photo is over 10 MB. Choose a smaller image and try again.');
      return;
    }
    var isVideo = ftype.indexOf('video/') === 0;
    if (file.size > (isVideo ? GM_MAX_TUS_BYTES : GM_MAX_BYTES)) {
      var errMsg2 = root.querySelector('[data-gm-upload-err-msg]');
      if (errMsg2) errMsg2.textContent = isVideo ? 'That video is over 1 GB. Try a shorter clip, or one filmed in 1080p.' : 'That file is too large to send.';
      gmUploadFail(attempt, errMsg2 ? errMsg2.textContent : 'That file is too large to send.');
      return;
    }

    // 2026-09-12: videos go to Cloudflare Stream so an iPhone .mov plays on
    // Android and desktop. Falls back to the R2 path if Stream is unavailable.
    if (ftype.indexOf('video/') === 0) {
      attempt.resumable = file.size > GM_MAX_BYTES;
      gmPrepareVideo(file, attempt).then(function(prepared) {
        if (!prepared || !gmUploadCurrent(attempt)) return;
        uploadVideoViaStream(prepared, function() { uploadFileToR2(prepared, attempt); }, attempt);
      });
      return;
    }
    // Photos go to Cloudflare Images (HEIC accepted, 1200px AVIF/WebP served). GIFs
    // stay on R2 so animation survives. Falls back to R2 if Images is unavailable.
    if (ftype.indexOf('image/') === 0 && ftype !== 'image/gif') { uploadImageViaImages(file, function (prepared) { uploadFileToR2(prepared || file, attempt); }, attempt); return; }
    uploadFileToR2(file, attempt);
  }

  function uploadFileToR2(file, attempt) {
    if (!gmUploadCurrent(attempt)) return;
    if (file.size > GM_MAX_R2_BYTES) {
      gmUploadFail(attempt, 'Our video service is busy right now, so this one is too large to send. Try a clip under 100 MB, or try again in a few minutes.');
      return;
    }
    if (GM_R2_TYPES.indexOf(gmFileType(file)) === -1) {
      gmUploadFail(attempt, 'That photo format needs our photo service, which is unavailable right now. Try a JPG or PNG.');
      return;
    }
    uploadSetState('busy');
    uploadSetBusyText('Uploading\u2026');
    var enc = encodeURIComponent;
    gmUploadJSON(GM_WORKER_URL, {
      method: 'POST',
      headers: {
        'Content-Type':      file.type,
        'X-Filename':        enc(file.name),
        'X-Recipient-Name':  enc((form.first + ' ' + form.last).trim()),
        'X-Recipient-Email': enc((form.email || '').trim()),
        'X-Recipient-Phone': enc((form.phone || '').replace(/\D/g,'')),
        'X-Message':         enc((form.message || '').trim()),
        'X-Hint':            enc((form.hint || '').trim()),
        'X-Secret-Word':     enc((form.secretWord || '').trim().toLowerCase()),
        // AUDIT FIX (2026-05-26): X-Sender-Name was hardcoded empty,
        // causing every gift in /pages/gift-media to show 'Unknown sender'.
        // Now we use the logged-in customer's full name (set in window.
        // __ssGmCustomer from Liquid). For guest checkouts the customer
        // isn't known until checkout completes - falls back to empty
        // and the dashboard shows 'Unknown sender' as before (the right
        // fix for guests is the Shopify Flow webhook from the gift-media
        // audit doc - it can stamp the buyer's name on the Worker record
        // after order/create fires).
        'X-Sender-Name':     enc((function() {
          var c = window.__ssGmCustomer;
          if (!c) return '';
          var name = ((c.firstName || '') + ' ' + (c.lastName || '')).trim();
          return name || (c.email || '');  // last resort: customer email
        })()),
        'X-Source':          'gift-message-modal',
      },
      body: file
    }, attempt, 30000)
      .then(function(r) {
        if (!gmUploadCurrent(attempt)) return;
        if (!r.ok) throw new Error((r.data && r.data.error) || 'Upload failed');
        var data = r.data;
        if (!data || typeof data.url !== 'string' || !data.url) throw new Error('Upload finished but the server did not return a file URL. Please try again.');
        var thumbEl = root.querySelector('[data-gm-upload-thumb]');
        if (thumbEl && gmFileType(file).indexOf('image/') === 0) {
          var safeUrl = ''; try { var u = new URL(data.url, window.location.origin); if (/^https?:$/.test(u.protocol)) safeUrl = u.href; } catch (_) {}
          if (safeUrl) {
            thumbEl.textContent = ''; var img = document.createElement('img');
            img.src = safeUrl; img.alt = ''; img.width = 38; img.height = 38; img.decoding = 'async';
            thumbEl.appendChild(img);
          }
        }
        uploadFinished(file, data.url, { shortId: data.shortId || data.id, key: data.key }, attempt);
      })
      .catch(function(err) {
        if (!gmUploadCurrent(attempt)) return;
        gmUploadFail(attempt, (err && err.message) ? String(err.message).slice(0, 200) : 'Upload failed - check your connection.');
      });
  }

  // Block step advance while uploading (chain validateStep)
  var __origValidateForUpload = validateStep;
  validateStep = function(n) {
    if (n === 1) {
      var failed = root.querySelector('[data-gm-upload-state="err"]:not([hidden])');
      if (failed) {
        showError('Your attachment did not upload. Try again or continue without it below.');
        openPhotoAddon();
        return false;
      }
    }
    return __origValidateForUpload(n);
  };

  // ─── Secret hint toggle ───────────────────────────────────────────────
  var hintToggle = root.querySelector('[data-gm-hint-toggle]');
  var hintBody   = root.querySelector('[data-gm-hint-body]');
  var hintIcon   = root.querySelector('[data-gm-hint-icon]');
  if (hintToggle && hintBody) {
    hintToggle.addEventListener('click', function() {
      var opening = hintToggle.getAttribute('aria-expanded') !== 'true';
      // The panel closing (its header, "Back to message" on phones) used to switch the hint
      // off while the typed hint stayed in the boxes, so it looked saved and silently wasn't.
      // Now a filled-in hint stays on when the panel closes; empty fields switch it off.
      var filled = !!((form.hint || '').trim() && (form.secretWord || '').trim());
      form.hintEnabled = opening ? true : filled;
      hintBody.hidden = !opening;
      hintToggle.classList.toggle('is-open', opening);
      hintToggle.classList.toggle('is-set', !opening && filled);
      hintToggle.setAttribute('aria-expanded', String(opening));
      gmSyncHintStatus();
      // Open/close state on the icon is driven by .is-open on the parent
      // button - CSS handles the visual swap so we don't wipe the SVG.
      syncAddonOpenStateForStep1();
      dirty = true;
      renderPreview();
    });
  }

  // A closed hint card says whether a hint is set, so the sender can see it was kept.
  function gmSyncHintStatus() {
    if (!hintToggle) return;
    var el = hintToggle.querySelector('[data-gm-hint-status]');
    var show = form.hintEnabled && hintToggle.getAttribute('aria-expanded') !== 'true';
    if (!el && !show) return;
    if (!el) {
      el = document.createElement('span');
      el.className = 'gm-addon-status';
      el.setAttribute('data-gm-hint-status', '');
      (hintToggle.querySelector('.gm-addon-main') || hintToggle).appendChild(el);
    }
    el.textContent = 'Hint set - tap to edit';
    el.hidden = !show;
    hintToggle.classList.toggle('is-set', show);
  }

  // Step 1 validation extension - if hint is on, both fields must be filled
  var __prevValidateForHint = validateStep;
  validateStep = function(n) {
    if (n === 1) {
      if (form.hintEnabled && (!form.hint.trim() || !form.secretWord.trim())) {
        showError('If you turn on the secret hint, fill in both fields - or turn it off.');
        return false;
      }
    }
    return __prevValidateForHint(n);
  };

  // ─── Email/SMS unlock rows - independent toggles ──────────────────────
  function syncUnlockRow(channel) {
    var row = root.querySelector('[data-gm-unlock-row="' + channel + '"]');
    var head = row && row.querySelector('[data-gm-unlock-toggle]');
    var on = (channel === 'email') ? form.emailUnlock : form.smsUnlock;
    if (row) row.classList.toggle('is-on', on);
    if (head) head.setAttribute('aria-pressed', String(on));
    if (channel === 'email' && row) {
      var field = row.querySelector('[data-gm-unlock-field="email"]');
      if (field) field.hidden = !on;
    }
  }

  root.querySelectorAll('[data-gm-unlock-toggle]').forEach(function(head) {
    var handleToggle = function() {
      var channel = head.getAttribute('data-gm-unlock-toggle');
      if (channel === 'email') {
        form.emailUnlock = !form.emailUnlock;
        var emailInput = root.querySelector('[data-gm-input="email"]');
        if (!form.emailUnlock) {
          form.email = '';
          if (emailInput) emailInput.value = '';
        }
      }
      else if (channel === 'sms') form.smsUnlock = !form.smsUnlock;
      syncUnlockRow(channel);
      if (channel === 'email' && form.emailUnlock && emailInput) emailInput.focus();
      dirty = true;
      renderPreview();
    };
    head.addEventListener('click', handleToggle);
    head.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleToggle(); }
    });
  });

  // ─── Notify dropdown - pure display, no state mutation ─────────────────
  // The dropdown is just a container that hides/shows the two channel
  // rows. It does NOT touch form.emailUnlock or form.smsUnlock. Per-channel
  // state lives entirely with the inner checkboxes. This removes the confusing
  // master-switch semantic from the previous iteration where opening the
  // dropdown silently flipped emailUnlock=true.
  var notifyToggle = root.querySelector('[data-gm-notify-toggle]');
  var notifyBody = root.querySelector('[data-gm-notify-body]');
  if (notifyToggle && notifyBody) {
    notifyToggle.addEventListener('click', function() {
      var willOpen = notifyToggle.getAttribute('aria-expanded') !== 'true';
      if (!willOpen && notifyBody.contains(document.activeElement)) notifyToggle.focus();
      notifyToggle.setAttribute('aria-expanded', String(willOpen));
      notifyToggle.classList.toggle('is-open', willOpen);
      notifyBody.hidden = !willOpen;
      // Closing the dropdown does NOT untick channels - predictable state.
      // The user is just hiding the display; their choices persist.
    });
  }

  // The hidden SMS row retains its existing input sync. Email requires a tick.
  function gmSyncChannelToField(channel) {
    var field = (channel === 'email')
      ? root.querySelector('[data-gm-input="email"]')
      : root.querySelector('[data-gm-input="phone"]');
    if (!field) return;
    var hasContent = !!(field.value || '').trim();
    var current = (channel === 'email') ? form.emailUnlock : form.smsUnlock;
    if (hasContent === current) return;  // already in sync
    if (channel === 'email') form.emailUnlock = hasContent;
    else if (channel === 'sms') form.smsUnlock = hasContent;
    syncUnlockRow(channel);
    dirty = true;
    renderPreview();
  }
  var emailField = root.querySelector('[data-gm-input="email"]');
  var phoneField = root.querySelector('[data-gm-input="phone"]');
  if (emailField) {
    var syncEmailField = function() {
      emailField.removeAttribute('aria-invalid');
    };
    emailField.addEventListener('input', syncEmailField);
    emailField.addEventListener('change', syncEmailField);
  }
  if (phoneField) {
    phoneField.addEventListener('input', function() { gmSyncChannelToField('sms'); });
    phoneField.addEventListener('change', function() { gmSyncChannelToField('sms'); });
  }

  // Initial sync - both channels start OFF. Email requires an explicit tick.
  form.emailUnlock = false;
  form.smsUnlock = false;
  syncUnlockRow('email');
  syncUnlockRow('sms');

  // ─── Step 2 validation ─────────────────────────────────────────────────
  var __prevValidateForDelivery = validateStep;
  validateStep = function(n) {
    if (n === 2) {
      if (form.emailUnlock) {
        var em = (form.email || '').trim();
        if (!em || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) {
          showError("Enter their email address, or untick email to skip the notification.");
          if (notifyToggle && notifyToggle.getAttribute('aria-expanded') !== 'true') notifyToggle.click();
          if (emailField) {
            emailField.setAttribute('aria-invalid', 'true');
            emailField.focus();
          }
          return false;
        }
      }
      if (form.smsUnlock) {
        var phoneClean = (form.phone || '').replace(/\D/g, '');
        // Market-aware mobile validation. AU primary uses 04xxxxxxxx / +614…;
        // UK market uses 07xxxxxxxxx / +447…. The AU-only regex previously
        // hard-blocked valid UK numbers, dead-ending the gift flow for UK
        // buyers who opted into SMS notify. GM_IS_UK is set from
        // localization.market.handle in the constants block above.
        var phoneOk = GM_IS_UK
          ? /^(\+?44|0)7\d{9}$/.test(phoneClean)
          : /^(\+?61|0)4\d{8}$/.test(phoneClean);
        if (!phoneOk) {
          showError(GM_IS_UK
            ? "Add a UK mobile (e.g. 07911 123456) - or clear the phone field to skip."
            : "Add an Australian mobile (e.g. 0412 345 678) - or clear the phone field to skip.");
          return false;
        }
      }
      return true;
    }
    return __prevValidateForDelivery(n);
  };

  // ─── Skip link - wipe digital message + jump to Review (step 3) ───────
  var skipBtn = root.querySelector('[data-gm-skip]');
  if (skipBtn) {
    skipBtn.addEventListener('click', function() {
      gmInvalidateUpload();
      // Wipe digital fields
      form.message = '';
      form.tone = '';
      form.photoAttached = false;
      form.attachmentURL = '';
      form._uploadMeta = null;
      form.hintEnabled = false;
      form.hint = '';
      form.secretWord = '';
      // Reflect into DOM
      var ta = root.querySelector('[data-gm-input="message"]'); if (ta) ta.value = '';
      var hintInput = root.querySelector('[data-gm-input="hint"]'); if (hintInput) hintInput.value = '';
      var secretInput = root.querySelector('[data-gm-input="secretWord"]'); if (secretInput) secretInput.value = '';
      root.querySelectorAll('[data-gm-tone]').forEach(function(b) { b.classList.remove('is-active'); });
      if (photoBody) photoBody.hidden = true;
      if (photoMount) photoMount.classList.remove('is-attached');
      if (photoToggle) {
        photoToggle.classList.remove('is-open', 'is-attached');
        photoToggle.setAttribute('aria-expanded', 'false');
      }
      if (hintBody) hintBody.hidden = true;
      if (hintToggle) {
        hintToggle.classList.remove('is-open');
        hintToggle.setAttribute('aria-expanded', 'false');
      }
      // SVG icon - no textContent reset needed; .is-open class drives state
      uploadSetState('idle');
      // Update counter
      if (typeof updateCounter === 'function') updateCounter();
      // Mark all steps complete and fire the commit flow directly.
      // The label "Skip card · Checkout" promises checkout, not a jump
      // to review - so honour that contract: write cart attributes +
      // redirect to /checkout. Default delivery (standard, email on)
      // already in form state means the commit handler has everything
      // it needs to fire without further input.
      done[1] = true; done[2] = true; done[3] = true;
      var commitBtnEl = root.querySelector('[data-gm-commit]');
      if (commitBtnEl) {
        commitBtnEl.disabled = false;
        commitBtnEl.click();
      } else {
        // Fallback: behave like the old skip → jump to review
        setStep(3);
        renderPreview();
      }
    });
  }

  // ─── Counter + line-cap for textarea ──────────────────────────────────
  // Reality check: messages print on an A5 card with a QR at the bottom.
  // 280 chars × 8 lines is the empirical fit before either the text
  // shrinks unreadably or it collides with the QR zone. Enforced front-end
  // (maxlength) + back-end (slice on cart attribute) + line cap below.
  var GM_MAX_CHARS = 280;
  var GM_MAX_LINES = 6;  // tightened from 8 - A5 card with QR needs realistic density; also lets textarea fit without internal scroll on small viewports
  var GM_CHAR_WARN_AT = Math.floor(GM_MAX_CHARS * 0.8);  // 224 - amber threshold

  // Delivery economics - market-aware. Standard delivery is free at or above
  // the free-ship threshold; below that, the standard fee is added. Express
  // always carries a surcharge. All values in the smallest currency unit
  // (cents/pence) so they line up with Shopify cart.total_price.
  //
  // 2026-05-28: refactored from AU-only hardcodes to Liquid-bridged per-market
  // constants. UK uses pence (GBP minor) and ~half the AU figures rounded to
  // clean numbers. AU figures unchanged from 2026-05-27 tier alignment:
  // raised free-ship threshold $100 → $119, cheapest boxes ($155-160) pay
  // $9.95 standard, premium ($119+) ships free, express $15 (AusPost domestic).
  //
  // GM_IS_UK - single market flag, consumed by the SMS phone validation in
  // validateStep() above (var-hoisted to this IIFE scope; the value is assigned
  // here at load, before any user interaction triggers validation). Added
  // 2026-05-30 alongside the market-aware SMS regex fix.
  var GM_CFG = window.__SS_GM_CFG || { uk:false, sym:'$', freeCents:11900, stdCents:995, expCents:1500 };
  var GM_IS_UK = GM_CFG.uk;
  var GM_CURRENCY_SYM = GM_CFG.sym;
  var GM_FREE_DELIVERY_THRESHOLD_CENTS = GM_CFG.freeCents;
  var GM_STANDARD_FEE_CENTS = GM_CFG.stdCents;
  var GM_EXPRESS_FEE_CENTS = GM_CFG.expCents;

  function updateCounter() {
    var c = root.querySelector('[data-gm-counter]');
    var totalEl = root.querySelector('.gm-paper-count-total');
    var linesEl = root.querySelector('[data-gm-line-count]');
    var paperCountEl = root.querySelector('.gm-paper-count');
    if (!c) return;

    var msg = form.message || '';
    var chars = msg.length;
    var lines = msg ? msg.split('\n').length : 0;

    c.textContent = String(chars);

    // Line count appears only once the writer is past 5 lines - quiet
    // until it matters, then explicit so they see the second limit.
    if (linesEl) {
      if (lines > 5) {
        linesEl.textContent = ' · ' + lines + '/' + GM_MAX_LINES + ' lines';
        linesEl.hidden = false;
      } else {
        linesEl.hidden = true;
      }
    }

    // Colour state on the whole counter - slate (default), amber (≥80%),
    // terracotta (at cap or at line cap).
    if (paperCountEl) {
      paperCountEl.classList.remove('is-warn', 'is-cap');
      if (chars >= GM_MAX_CHARS || lines >= GM_MAX_LINES) {
        paperCountEl.classList.add('is-cap');
      } else if (chars >= GM_CHAR_WARN_AT || lines >= GM_MAX_LINES - 1) {
        paperCountEl.classList.add('is-warn');
      }
    }

    // Hint line - adaptive. Empty textarea shows the default "leave blank"
    // message; the moment they start typing it becomes a live remaining
    // counter so they can always glance and see headroom.
    var hintEl = root.querySelector('[data-gm-paper-hint]');
    if (hintEl) {
      if (!chars) {
        hintEl.textContent = hintEl.getAttribute('data-gm-default-text') || '';
        hintEl.classList.remove('is-warn', 'is-cap');
      } else {
        var charsLeft = Math.max(0, GM_MAX_CHARS - chars);
        var linesLeft = Math.max(0, GM_MAX_LINES - lines);
        var parts = [];
        // Char remaining - pluralise correctly + zero state
        if (charsLeft === 0) parts.push('Character limit reached');
        else if (charsLeft === 1) parts.push('1 character left');
        else parts.push(charsLeft + ' characters left');
        // Lines only mentioned when getting tight (past 5 lines used)
        if (lines > 5) {
          if (linesLeft === 0) parts.push('line limit reached');
          else if (linesLeft === 1) parts.push('room for 1 more line');
          else parts.push('room for ' + linesLeft + ' more lines');
        }
        hintEl.textContent = parts.join(' · ');
        // Mirror the counter's colour state so the hint line shifts too
        hintEl.classList.remove('is-warn', 'is-cap');
        if (chars >= GM_MAX_CHARS || lines >= GM_MAX_LINES) {
          hintEl.classList.add('is-cap');
        } else if (chars >= GM_CHAR_WARN_AT || lines >= GM_MAX_LINES - 1) {
          hintEl.classList.add('is-warn');
        }
      }
    }
  }
  // Counter updates on every keystroke in the message textarea
  root.addEventListener('input', function(e) {
    if (e.target.getAttribute && e.target.getAttribute('data-gm-input') === 'message') updateCounter();
  });

  // Keep the six-line cap across hardware keyboards, mobile keyboards,
  // paste and dictation. Feedback stays below the card, never over Done.
  function gmShowLineCapFeedback() {
    updateCounter();
    var status = root.querySelector('[data-gm-limit-status]');
    if (status) status.textContent = 'Line limit reached. Edit or remove a line to add another.';
  }
  function gmCandidate(target, inserted) {
    return target.value.slice(0, target.selectionStart) + inserted + target.value.slice(target.selectionEnd);
  }
  root.addEventListener('beforeinput', function(e) {
    var target = e.target;
    if (!target || target.getAttribute('data-gm-input') !== 'message') return;
    if (e.inputType !== 'insertLineBreak' && e.inputType !== 'insertParagraph') return;
    if (gmCandidate(target, '\n').split('\n').length > GM_MAX_LINES) {
      e.preventDefault();
      gmShowLineCapFeedback();
    }
  });
  root.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter') return;
    var target = e.target;
    if (!target || target.getAttribute('data-gm-input') !== 'message') return;
    if (gmCandidate(target, '\n').split('\n').length > GM_MAX_LINES) {
      e.preventDefault();
      gmShowLineCapFeedback();
    }
  });
  // Paste at the selection, preserving text after the cursor. The previous
  // check appended the clipboard to the whole value and could reject a
  // perfectly valid replacement or silently drop the existing suffix.
  root.addEventListener('paste', function(e) {
    var target = e.target;
    if (!target || target.getAttribute('data-gm-input') !== 'message') return;
    var clipboard = e.clipboardData || window.clipboardData;
    var pasted = clipboard && clipboard.getData('text');
    if (!pasted) return;
    if (gmCandidate(target, pasted).split('\n').length <= GM_MAX_LINES) return;
    e.preventDefault();
    var original = target.value || '';
    var start = target.selectionStart;
    var end = target.selectionEnd;
    var remainingNewlines = GM_MAX_LINES - (original.slice(0, start) + original.slice(end)).split('\n').length;
    var fitted = '';
    for (var i = 0; i < pasted.length; i++) {
      if (pasted[i] === '\n') {
        if (remainingNewlines <= 0) break;
        remainingNewlines--;
      }
      fitted += pasted[i];
    }
    fitted = fitted.slice(0, Math.max(0, GM_MAX_CHARS - original.length + end - start));
    target.setRangeText(fitted, start, end, 'end');
    form.message = target.value;
    dirty = true;
    schedulePreviewRender();
    gmShowLineCapFeedback();
  });
  // Some mobile keyboards and voice input bypass keydown/beforeinput. Clamp
  // their resulting value on input, then sync the actual saved message.
  function gmClampMessage(target) {
    var value = target.value;
    var limited = value.split('\n').slice(0, GM_MAX_LINES).join('\n').slice(0, GM_MAX_CHARS);
    if (limited !== value) {
      target.value = limited;
      form.message = limited;
      schedulePreviewRender();
      gmShowLineCapFeedback();
    } else {
      var status = root.querySelector('[data-gm-limit-status]');
      if (status) status.textContent = '';
      updateCounter();
    }
  }
  root.addEventListener('input', function(e) {
    if (e.target.getAttribute && e.target.getAttribute('data-gm-input') === 'message' && !e.isComposing) gmClampMessage(e.target);
  });
  root.addEventListener('compositionend', function(e) {
    if (e.target.getAttribute && e.target.getAttribute('data-gm-input') === 'message') gmClampMessage(e.target);
  });

  // ─── Dynamic textarea placeholder ──────────────────────────────────────
  // Free-form: writer types the full card text, including their own
  // greeting opener. Placeholder samples that pattern with their first
  // name (or "Hannah" as a generic example) so they see the shape.
  function syncMessagePlaceholder() {
    var ta = root.querySelector('[data-gm-input="message"]');
    if (!ta) return;
    var firstTrim = (form.first || '').trim();
    ta.placeholder = firstTrim
      ? 'Dear ' + firstTrim + ', …'
      : 'Dear Hannah, …';
  }
  root.addEventListener('input', function(e) {
    if (e.target.getAttribute && e.target.getAttribute('data-gm-input') === 'first') syncMessagePlaceholder();
  });
  syncMessagePlaceholder();

  // Esc closes - guards against sibling modals being open on top.
  // Mirrors cart-drawer-v3's defensive sibling-selector pattern.
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    if (root.getAttribute('data-open') !== 'true') return;
    // Don't close gift modal if a higher-priority modal/dialog is open on top of it
    if (document.querySelector('.pd-root[aria-hidden="false"], .gd-root[aria-hidden="false"], .search-modal[open], [data-modal-open="true"]')) return;
    // AUDIT FIX (2026-05-26): if user is in mobile focus mode (writing),
    // Esc should exit focus mode first - not close the whole modal and
    // discard their in-progress message. Matches iOS sheet conventions.
    if (root.classList.contains('is-focus-mode')) {
      exitFocusMode();
      e.stopPropagation();
      return;
    }
    if (closeOpenAddon()) {
      e.stopPropagation();
      return;
    }
    window.closeGiftMessageModal({ confirmIfDirty: true });
    e.stopPropagation();
  });

  // Focus trap - Tab cycles within the modal when open.
  // WCAG SC 2.4.3 + aria-modal requirement.
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Tab') return;
    if (root.getAttribute('data-open') !== 'true') return;
    var focusables = root.querySelectorAll(
      'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"], [contenteditable="true"]'
    );
    var visible = Array.prototype.filter.call(focusables, function(el) {
      return el.offsetParent !== null && !el.hasAttribute('hidden');
    });
    if (visible.length === 0) return;
    var first = visible[0];
    var last  = visible[visible.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // ─── Error toast ───────────────────────────────────────────────────────
  // Inline toast (role="alert" on the markup) - replaces alert() so failures
  // don't blow context out of the modal. AT picks it up the moment we un-hide.
  function showError(msg, persistent) {
    var el = root.querySelector('[data-gm-error]');
    if (!el) return;
    if (root.classList.contains('is-focus-mode')) exitFocusMode();
    // AUDIT FIX (2026-05-26): cap message length so an Error.message
    // containing a stack trace or upstream API blob can't blow out the
    // toast layout. 240 chars covers any reasonable human-facing message.
    el.textContent = String(msg || '').slice(0, 240);
    el.hidden = false;
    gmWaitNote('');
    if (errorTimer) clearTimeout(errorTimer);
    errorTimer = persistent ? null : setTimeout(function() { el.hidden = true; }, 6000);
  }

  // ─── escapeHtml helper (if not already defined elsewhere in this file) ─
  if (typeof escapeHtml !== 'function') {
    var escapeHtml = function(s) {
      return String(s).replace(/[&<>"']/g, function(c) {
        return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
      });
    };
  }

  // ─── Render Step 3 (Review) - pulls live cart + summarises form state ─
  // AUDIT FIX (2026-05-26): request token to guard against stale-response
  // overwrite. Without it, if a user enters Step 3 → quickly goes Back to
  // Step 2 → comes back to Step 3, two /cart.js requests are in flight and
  // the slower one wins (could overwrite newer cart state with older data).
  var __gmReviewReqToken = 0;
  var __gmReviewAbort = null;
  function renderReview() {
    var myToken = ++__gmReviewReqToken;
    if (__gmReviewAbort) __gmReviewAbort.abort();
    var controller = new AbortController();
    __gmReviewAbort = controller;
    var reviewTimeout = setTimeout(function() { controller.abort(); }, 12000);
    var reviewCommit = root.querySelector('[data-gm-commit]');
    var reviewRetry = root.querySelector('[data-gm-review-retry]');
    var reviewTotal = root.querySelector('[data-gm-review-total]');
    if (reviewCommit) reviewCommit.disabled = true;
    if (reviewRetry) reviewRetry.hidden = true;
    if (reviewTotal) reviewTotal.textContent = 'Loading…';
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, signal: controller.signal })
      .then(function(r) {
        if (!r.ok) throw new Error('Basket unavailable');
        return r.json();
      })
      .then(function(cart) {
        // Bail if a newer renderReview call has fired since we started.
        if (myToken !== __gmReviewReqToken) return;
        var hasItems = !!(cart.items && cart.items.length);
        var gateMsg = gmCartGate(cart);
        if (reviewCommit) reviewCommit.disabled = !hasItems || !!gateMsg;
        if (!hasItems) showError('Your basket is empty. Close this panel to choose a gift.');
        var gateLine = root.querySelector('[data-gm-review-gate]');
        if (gateLine && gateLine.parentNode) gateLine.parentNode.removeChild(gateLine);
        var gateNote = root.querySelector('[data-gm-address-note]');
        if (gateMsg && gateNote && gateNote.parentNode) {
          gateLine = document.createElement('p');
          gateLine.className = 'gm-step-sub gm-flow-note gm-review-gate';
          gateLine.setAttribute('data-gm-review-gate', '');
          gateLine.setAttribute('role', 'alert');
          gateLine.textContent = gateMsg;
          gateNote.parentNode.insertBefore(gateLine, gateNote);
        }
        // Items chips
        var itemsEl = root.querySelector('[data-gm-review-items]');
        if (itemsEl) {
          var itemsHtml = (cart.items || []).map(function(i) {
            if (window.SSBoxBundles) i = window.SSBoxBundles.display(i);
            var variantPart = (i.variant_title && i.variant_title !== 'Default Title')
              ? ' - ' + escapeHtml(i.variant_title) : '';
            var printDesign = i.properties && i.properties['Print design'];
            if (printDesign) variantPart += ' · Print: ' + escapeHtml(printDesign);
            return '<span class="gm-chip">' + escapeHtml(i.product_title) + variantPart + ' × ' + i.quantity + '</span>';
          }).join('');
          itemsEl.innerHTML = itemsHtml || '<span class="gm-chip">(empty cart)</span>';
        }

        // Message
        var msgEyebrow = root.querySelector('[data-gm-review-msg-eyebrow]');
        if (msgEyebrow) msgEyebrow.textContent = 'Message' + (form.tone ? ' · ' + form.tone + ' tone' : '');
        var msgEl = root.querySelector('[data-gm-review-message]');
        if (msgEl) msgEl.textContent = form.message ? '"' + form.message + '"' : '- card included blank -';
        var hintEl = root.querySelector('[data-gm-review-hint]');
        if (hintEl) {
          if (form.hintEnabled && form.hint.trim()) {
            hintEl.textContent = 'Unlock hint: ' + form.hint.trim();
            hintEl.hidden = false;
          } else {
            hintEl.hidden = true;
          }
        }

        // Whisper-light last nudge: if no photo/video is attached, offer it once
        // more - calm, inline, in the Message card. Never blocks; tapping jumps
        // back to the Message step and opens the photo add-on.
        var oldPh = root.querySelector('[data-gm-review-photohint]');
        if (oldPh && oldPh.parentNode) oldPh.parentNode.removeChild(oldPh);
        var hasMediaRv = !!(form.attachmentURL && form.attachmentURL.length);
        var addrNote = root.querySelector('[data-gm-address-note]');
        if (addrNote && addrNote.parentNode && !hasMediaRv && gmUploadInFlight()) {
          var up = document.createElement('p');
          up.className = 'gm-step-sub gm-flow-note gm-review-uploading';
          up.setAttribute('data-gm-review-photohint', '');
          up.textContent = 'Your photo or video is still uploading. It will finish before checkout.';
          addrNote.parentNode.insertBefore(up, addrNote);
          gmLockCommitWidth();
        } else if (addrNote && addrNote.parentNode && hasMediaRv) {
          var rcw = root.querySelector('[data-gm-commit]');
          if (rcw && rcw.getAttribute('aria-disabled') !== 'true') rcw.style.minWidth = '';
          // phones hide the Message card and the desktop rail, so say it here
          var att = document.createElement('p');
          att.className = 'gm-step-sub gm-flow-note gm-review-uploading' + (form._uploadMeta && form._uploadMeta.streamUid ? '' : ' gm-mobile-only');
          att.setAttribute('data-gm-review-photohint', '');
          att.textContent = form._uploadMeta && form._uploadMeta.streamUid ? GM_VIDEO_UPLOADED_NOTE : 'Your photo or video is attached.';
          addrNote.parentNode.insertBefore(att, addrNote);
        } else if (addrNote && addrNote.parentNode && !hasMediaRv) {
          var rcn = root.querySelector('[data-gm-commit]');
          if (rcn && rcn.getAttribute('aria-disabled') !== 'true') rcn.style.minWidth = '';
          var ph = document.createElement('p');
          ph.className = 'gm-step-sub gm-flow-note gm-review-nudge';
          ph.setAttribute('data-gm-review-photohint', '');
          ph.innerHTML = 'No photo or video yet - <a href="#" data-gm-review-addphoto style="color:#a85e38;text-decoration:underline;text-underline-offset:2px;">add one they&rsquo;ll keep &rarr;</a>';
          addrNote.parentNode.insertBefore(ph, addrNote);
          var aPh = ph.querySelector('[data-gm-review-addphoto]');
          if (aPh) aPh.addEventListener('click', function(e) { e.preventDefault(); setStep(1); openPhotoAddon(); });
        }

        // Delivery + notify
        var delEl = root.querySelector('[data-gm-review-delivery]');
        if (delEl) delEl.textContent = 'Choose Standard or Express at checkout, where available';
        var notifyEl = root.querySelector('[data-gm-review-notify]');
        if (notifyEl) {
          var parts = [];
          if (form.emailUnlock) parts.push('Email on arrival: ' + (form.email || '').trim());
          if (form.smsUnlock) parts.push('SMS');
          notifyEl.textContent = parts.length
            ? parts.join(' + ')
            : "No email - they\u2019ll find the card in the box";
        }

        // Product subtotal only. Checkout determines shipping availability, selection and price.
        var subtotal = cart.total_price || 0;
        var total = hasItems ? subtotal : 0;
        var totalEl = root.querySelector('[data-gm-review-total]');
        if (totalEl) totalEl.textContent = GM_CURRENCY_SYM + (total / 100).toFixed(2).replace(/\.00$/, '');
      })
      .catch(function(err) {
        if (myToken !== __gmReviewReqToken) return;
        if (reviewTotal) reviewTotal.textContent = 'Unavailable';
        if (reviewRetry) reviewRetry.hidden = false;
        showError('Could not load your basket. Your message is safe here. Check your connection and tap Retry.');
        console.error('[gift-modal] renderReview cart fetch failed', err);
      })
      .finally(function() { clearTimeout(reviewTimeout); });
  }

  var reviewRetryBtn = root.querySelector('[data-gm-review-retry]');
  if (reviewRetryBtn) reviewRetryBtn.addEventListener('click', function() {
    var error = root.querySelector('[data-gm-error]');
    if (error) error.hidden = true;
    renderReview();
  });

  // ─── Patch setStep to call renderReview on entering step 3 ─────────────
  var __prevSetStepForReview = setStep;
  setStep = function(n) {
    __prevSetStepForReview(n);
    if (n !== 3) gmCancelCommit();   // the waits only notice on their next tick
    if (n === 3) renderReview();
  };

  // ─── Side-panel arrival line follows the journey (2026-10-10) ───────────
  // It was static markup, so Review still said "Add their email on the next step" after an email was set.
  var gmArrivalEl = root.querySelector('[data-gm-rA-arrival]');
  function gmUpdateArrival() {
    if (!gmArrivalEl) return;
    var who = String(form.first || '').trim() || 'them';
    var hasEmail = form.emailUnlock && /\S+@\S+\.\S+/.test(String(form.email || ''));
    var text;
    if (step <= 1) text = 'Want them told the moment it lands? Add their email on the next step.';
    else if (hasEmail) text = 'We\u2019ll email ' + who + ' the moment it lands.';
    else if (form.emailUnlock) text = 'Add their email and we\u2019ll tell them the moment it lands.';
    else if (step === 2) text = 'Want them told the moment it lands? Tick \u201cEmail them on delivery\u201d.';
    else text = 'They\u2019ll discover your card when they open the box.';
    var icon = gmArrivalEl.querySelector('span[aria-hidden="true"]');
    gmArrivalEl.textContent = ' ' + text;
    if (icon) gmArrivalEl.insertBefore(icon, gmArrivalEl.firstChild);
  }
  // Review card preview (phones fit the screen): fade the last line only when a long message is actually cut off
  var gmRvBody = root.querySelector('.gm-rv-postcard-body');
  if (gmRvBody && 'ResizeObserver' in window) {
    var gmRvClip = function() { gmRvBody.classList.toggle('is-clipped', gmRvBody.scrollHeight > gmRvBody.clientHeight + 2); };
    new ResizeObserver(gmRvClip).observe(gmRvBody);
    new MutationObserver(gmRvClip).observe(gmRvBody, { childList: true, characterData: true, subtree: true });
  }
  // Phones: the full consent notice floats over the form (so Message never scrolls); tap it to close (links still work)
  root.addEventListener('click', function(e) {
    var f = e.target && e.target.closest && e.target.closest('.gm-consent-full');
    if (!f || e.target.closest('a') || !window.matchMedia('(max-width: 749px)').matches) return;
    var n = f.closest('[data-gm-consent-note]');
    if (!n || !n.classList.contains('is-open')) return;
    n.classList.remove('is-open');
    var t = n.querySelector('.gm-consent-toggle');
    if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
  });
  var __prevSetStepForArrival = setStep;
  setStep = function(n) { __prevSetStepForArrival(n); gmUpdateArrival(); };
  var __prevRenderPreviewForArrival = renderPreview;
  renderPreview = function() { var r = __prevRenderPreviewForArrival.apply(this, arguments); gmUpdateArrival(); return r; };
  root.addEventListener('input', function(e) { if (e.target && e.target.matches && e.target.matches('[data-gm-input]')) gmUpdateArrival(); });

  // The cart drawer won't check out without exactly one gift box (and a confirmed 18+ wine), but
  // the modal's own Checkout went straight to /checkouts/. Same rule, same words, enforced here.
  function gmCartGate(cart) {
    var items = (cart && cart.items) || [];
    if (!items.length) return '';
    if (window.SSBoxBundles && window.SSBoxBundles.needsMigration(cart)) return 'Please remove this box and add it again with your chosen print.';
    var boxHandles = ['dusk-box', 'twilight-box', 'midnight-box', 'little-comforts-box', 'horizon-box'];
    var boxType = String((window.__CT_V3_CFG && window.__CT_V3_CFG.giftProductType) || 'Gift Box').toLowerCase();
    var boxes = items.reduce(function(n, i) {
      var isBox = String(i.product_type || '').toLowerCase() === boxType ||
        !!(i.properties && i.properties._gift_box) || /^gift-box-/.test(i.handle || '') || boxHandles.indexOf(i.handle) !== -1;
      return n + (isBox ? Number(i.quantity || 0) : 0);
    }, 0);
    var wineUnconfirmed = items.some(function(i) {
      return i.handle === 'piccolo-wine' && (!i.properties || i.properties['Recipient 18+'] !== 'Confirmed');
    });
    if (wineUnconfirmed) return 'Remove the wine and add it again, confirming you and the recipient are both 18 or over, before checkout.';
    if (boxes > 1) return 'One gift box per order. Remove the extra box before checkout.';
    if (boxes < 1) return 'A gift box is required to check out. Build your box to continue.';
    return '';
  }

  // While an upload is in flight the checkout button will read "Finishing… N%": give it that
  // width as Review renders, so tapping it doesn't make the pill grow.
  function gmLockCommitWidth() {
    var cb = root.querySelector('[data-gm-commit]');
    if (!cb || cb.style.minWidth || !cb.offsetWidth) return;
    var html = cb.innerHTML;
    cb.textContent = 'Finishing\u2026 99%';
    var w = cb.offsetWidth;
    cb.innerHTML = html;
    cb.style.minWidth = Math.max(w, cb.offsetWidth) + 'px';
  }

  // While bytes are still uploading, explain the wait and automatic checkout hand-off.
  // Show the note after 2s so a quick upload never flashes it.
  var gmWaitTimer = null;
  function gmWaitNote(text) {
    var n = root.querySelector('[data-gm-wait-note]');
    if (!text) {
      clearTimeout(gmWaitTimer); gmWaitTimer = null;
      if (n) { n.hidden = true; n.textContent = ''; }
      return;
    }
    var foot = root.querySelector('.gm-foot');
    if (!n && foot) {
      n = document.createElement('p');
      n.className = 'gm-wait-note';
      n.setAttribute('data-gm-wait-note', '');
      n.hidden = true;
      foot.parentNode.insertBefore(n, foot);
    }
    if (!n) return;
    if (n.textContent !== text) n.textContent = text;
    if (n.hidden && !gmWaitTimer) {
      gmWaitTimer = setTimeout(function() {
        gmWaitTimer = null;
        if (n.textContent) { n.hidden = false; gmAnnounce(n.textContent); }
      }, 2000);
    }
  }
  function gmUploadWaitText(attempt) {
    if (!attempt || !attempt.video) return 'Almost there. Checkout opens on its own.';
    if (attempt.preparing) return (gmSecondsLeft(gmProgress.secs) || 'Your video is preparing. ') + 'Checkout opens on its own when it\u2019s ready - just don\u2019t close this tab.';
    if (gmProgress.pct >= 100) return 'Almost there. Checkout opens on its own when it\u2019s ready - just don\u2019t close this tab.';
    return (gmSecondsLeft(gmProgress.secs) || 'Your video is still sending. ') + 'Checkout opens on its own when it\u2019s ready - just don\u2019t close this tab.';
  }

  // Every Checkout tap is one intent. Back, close, reopen, Skip and a new, failed or removed upload end
  // it, so a slow response from an abandoned tap (gate check, private-link mint, cart save, upload or
  // encode wait) can never write another draft to the cart, revive a checkout, or open /checkout.
  var gmCommitIntent = 0;
  function gmCancelCommit() {
    gmCommitIntent++;
    gmWaitNote('');
    var b = root.querySelector('[data-gm-commit]');
    if (!b) return;
    b.__gmGateChecked = false;
    if (b.getAttribute('aria-disabled') === 'true' || b.classList.contains('is-waiting')) {
      b.classList.remove('is-waiting');
      b.removeAttribute('aria-busy');
      b.removeAttribute('aria-disabled');
      b.style.minWidth = '';
      if (b.__gmIdleHTML) b.innerHTML = b.__gmIdleHTML;
    }
  }
  // Back from checkout restores the page from the bfcache with Checkout still
  // disabled on "Saving…".
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) gmCancelCommit();
  });

  // Non-blocking uploads (2026-10-06): the sender can reach Review while the file is
  // still sending. The commit waits here, mirrors the progress on the button, and
  // carries on by itself when the upload lands: one tap, and the media is never lost.
  function gmCommitWhenUploaded(btn, originalLabel) {
    var attempt = gmUploadAttempt, intent = gmCommitIntent;
    function label() { return gmProgress.pct > 0 && gmProgress.pct < 100 ? 'Finishing\u2026 ' + gmProgress.pct + '%' : 'Finishing\u2026'; }
    btn.classList.add('is-waiting');
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Finishing\u2026 99%';   // widest label: lock the width so it never jitters
    btn.style.minWidth = btn.offsetWidth + 'px';
    btn.textContent = label();
    gmWaitNote(gmUploadWaitText(attempt));
    var timer = setInterval(function() {
      var gone = root.getAttribute('data-open') !== 'true' || gmUploadAttempt !== attempt || attempt.cancelled || step !== 3 || intent !== gmCommitIntent;
      if (!gone && attempt.finished) {
        stop(true);   // keep the width into "Saving…" so the button doesn't snap smaller
        btn.click();
        return;
      }
      if (gone) {
        stop();
        if (root.querySelector('[data-gm-upload-state="err"]:not([hidden])')) {
          showError('Your photo or video didn\u2019t upload. Try again, or remove it before continuing.');
          setStep(1);
          openPhotoAddon();
          gmFocusRetry();
        }
        return;
      }
      btn.textContent = label();
      gmWaitNote(gmUploadWaitText(attempt));
    }, 250);
    function stop(keepWidth) {
      clearInterval(timer);
      if (intent !== gmCommitIntent) return;
      // Keep a visible upload note through the hand-off; hide a pending note to avoid a flash.
      var shown = root.querySelector('[data-gm-wait-note]:not([hidden])');
      if (!keepWidth || !shown) gmWaitNote('');
      btn.classList.remove('is-waiting');
      btn.removeAttribute('aria-busy');
      if (!keepWidth) btn.style.minWidth = '';
      if (originalLabel) btn.innerHTML = originalLabel;
      btn.removeAttribute('aria-disabled');
    }
  }

  // Run this brief rejection check alongside the basket read. Encoding can finish
  // independently; even a stalled response body must release checkout on time.
  function gmCheckUploadedVideo(uid) {
    return new Promise(function(resolve) {
      var ctl = new AbortController(), stopped = false;
      var timer = setTimeout(function() { finish(null); }, 1500);
      function finish(st) {
        if (stopped) return;
        stopped = true;
        clearTimeout(timer);
        ctl.abort();
        resolve(st);
      }
      fetch(GM_WORKER_URL + '/stream/status/' + uid, { cache: 'no-store', signal: ctl.signal })
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(finish, function() { finish(null); });
    });
  }

  // After a failure sends the sender back to Message, put focus on the way forward.
  function gmFocusRetry() {
    setTimeout(function() {
      var r = root.querySelector('[data-gm-upload-retry]');
      if (r && r.offsetParent) { try { r.focus({ preventScroll: false }); } catch (_) {} }
    }, 80);
  }

  // A failed check focuses its field while that step is still hidden, and the step change then blurs
  // inputs: once the step is showing, put the cursor on the field that needs fixing.
  function gmFocusInvalid(n) {
    setTimeout(function() {
      var bad = root.querySelector('[data-gm-step].is-active [aria-invalid="true"]') || (n === 1 ? root.querySelector('[data-gm-input="first"]') : null);
      if (bad && bad.offsetParent) { try { bad.focus(); } catch (_) {} }
    }, 60);
  }

  // ─── Commit handler - write cart attributes + redirect to checkout ────
  var commitBtn = root.querySelector('[data-gm-commit]');
  if (commitBtn) {
    commitBtn.addEventListener('click', function() {
      var btn = this;
      if (btn.disabled) return;
      if (btn.hasAttribute('aria-disabled') && btn.getAttribute('aria-disabled') === 'true') return;
      for (var requiredStep = 1; requiredStep <= 2; requiredStep++) {
        if (!validateStep(requiredStep)) {
          setStep(requiredStep);
          gmFocusInvalid(requiredStep);
          return;
        }
      }
      if (gmCartSaveUncertain) {
        showError(gmCartSaveUnknownMessage, true);
        return;
      }
      var intent = ++gmCommitIntent;
      var live = function() { return intent === gmCommitIntent; };
      btn.setAttribute('aria-disabled', 'true');
      var originalLabel = btn.innerHTML;
      btn.__gmIdleHTML = originalLabel;
      btn.textContent = gmUploadInFlight() ? 'Finishing…' : 'Saving…';

      var phoneClean = (form.phone || '').replace(/\D/g, '');
      var anyNotify = form.emailUnlock || form.smsUnlock;
      // The secret hint unlocks the photo or video, so it only travels with one.
      var __hintOn = form.hintEnabled && !!form.attachmentURL;

      // Force-zero rule: if a channel is OFF, write '' (not omitted)
      // to defend against Shopify Flow firing on stale DOM values
      var recipientEmail = form.emailUnlock ? (form.email || '').trim() : '';
      var recipientPhone = form.smsUnlock ? phoneClean : '';

      // P1 (2026-05-30): re-validate the recipient email AT COMMIT, not just on
      // step-advance. Autofill / edit-after-untick paths can leave a malformed
      // address in form.email while emailUnlock is true. Without this guard a
      // typo'd address gets written and Shopify Flow emails the unlock link into
      // the void - the recipient silently never receives their gift. If it fails
      // validation, stop the commit and send the user back to fix it rather than
      // shipping a dead address. Mirrors the Step-2 advance check.
      if (form.emailUnlock && (!recipientEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(recipientEmail))) {
        showError("That recipient email looks off - please double-check it so their unlock link doesn't bounce.");
        // Restore the button out of its "Saving…" state and re-enable it.
        if (originalLabel) btn.innerHTML = originalLabel;
        btn.removeAttribute('aria-disabled');
        if (typeof setStep === 'function') setStep(2);
        var emInput = root.querySelector('[data-gm-input="email"]');
        if (emInput) emInput.setAttribute('aria-invalid', 'true');
        gmFocusInvalid(2);
        return;
      }

      // ── Media-loss guard (2026-06-01 GTM fix) ────────────────────────
      // If the sender opened the photo/video addon and an upload is still
      // in-flight ('busy') or FAILED ('err'), block the commit. Without this
      // the sender believes they attached media, but form.attachmentURL is
      // empty, so the gift ships with no photo/video and the recipient
      // silently gets a media-less gift. Reuse the existing upload-state DOM.
      var __upBusy = root.querySelector('[data-gm-upload-state="busy"]:not([hidden])');
      var __upErr  = root.querySelector('[data-gm-upload-state="err"]:not([hidden])');
      if (__upBusy && gmUploadInFlight()) {
        gmCommitWhenUploaded(btn, originalLabel);
        return;
      }
      if (!btn.__gmGateChecked) {
        var uploadAttempt = gmUploadAttempt;
        var streamUid = form._uploadMeta && form._uploadMeta.streamUid;
        var videoCheck = streamUid && !__upBusy && !__upErr && !gmStreamReady[streamUid]
          ? gmCheckUploadedVideo(streamUid) : Promise.resolve(null);
        var basketCheck = gmFetchWithTimeout('/cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } })
          .then(function(r) { if (!r.ok) throw new Error('basket ' + r.status); return r.json(); })
          .then(function(cart) { return cart && cart.items ? cart : Promise.reject(new Error('basket unreadable')); });
        Promise.all([basketCheck, videoCheck])
          .then(function(checked) {
            if (!live() || gmUploadAttempt !== uploadAttempt || (uploadAttempt && uploadAttempt.cancelled)) return;
            var cart = checked[0], video = checked[1];   // Back, close or a new tap since: that tap is over
            // Shopify's checkout has no gift-box rule of its own, so this check is the gate: an
            // empty or unreadable basket stops here (the tap can simply be retried).
            var msg = cart.items.length ? gmCartGate(cart) : 'Your basket is empty. Close this panel to choose a gift.';
            if (msg) {
              if (originalLabel) btn.innerHTML = originalLabel;
              btn.removeAttribute('aria-disabled');
              btn.style.minWidth = '';
              showError(msg);
              if (step !== 3) setStep(3);
              return;
            }
            if (video && video.state === 'error') {
              setStep(1);
              gmUploadFail(uploadAttempt, /DURATION/i.test(video.errorCode || '') ? 'That video is over 3 minutes. Trim it a little and try again.' : 'That video could not be processed. Try a different clip.');
              openPhotoAddon();
              renderPreview();
              gmFocusRetry();
              return;
            }
            if (video && video.ready) gmStreamReady[streamUid] = true;
            btn.__gmGateChecked = true;
            if (originalLabel) btn.innerHTML = originalLabel;
            btn.removeAttribute('aria-disabled');
            btn.click();
          }, function() {
            if (!live()) return;
            if (originalLabel) btn.innerHTML = originalLabel;
            btn.removeAttribute('aria-disabled');
            btn.style.minWidth = '';
            showError('We couldn\u2019t check your basket. Check your connection and try again.');
          });
        return;
      }
      btn.__gmGateChecked = false;

      if (__upBusy || __upErr) {
        showError(__upBusy
          ? 'Your photo or video is still uploading - give it a moment, then try again.'
          : 'Your photo or video didn’t upload. Try again, or remove it before continuing.');
        if (originalLabel) btn.innerHTML = originalLabel;
        btn.removeAttribute('aria-disabled');
        if (typeof setStep === 'function') setStep(1);
        return;
      }

      // ── Direct-link shortId (2026-06-01) ─────────────────────────────
      // The Worker upload endpoint returns only { url } (never a shortId),
      // so 'Unlock short ID' below was ALWAYS empty - for media AND medialess
      // gifts - and every recipient email fell back to a bare /pages/unlock
      // link where the secret-phrase field never renders (the recipient only
      // ever saw the phone-lookup screen). We now mint a real unlock record
      // via the Worker's /unlock/create in the gate AFTER this handler body,
      // stamp its id onto _uploadMeta, and the attribute below picks it up so
      // Shopify Flow can build /pages/unlock?g=<id>. The whole commit body is
      // wrapped so the mint resolves first; the gate calls __proceedCommit()
      // in every path (success, no-id, or network failure → bare-link
      // fallback preserved, checkout never blocked).
      var __proceedCommit = function () {
      if (!live()) return;
      var attributes = {
        // Preserved keys consumed by Shopify Flow (do not rename)
        'Recipient first name':    (form.first || '').trim(),
        'Recipient last name':     (form.last || '').trim(),
        'Recipient phone':         recipientPhone,
        'Recipient relationship':  form.rel || '',
        'Recipient email':         recipientEmail,
        'Unlock hint':             __hintOn ? (form.hint || '').trim() : '',
        'Unlock answer':           __hintOn ? (form.secretWord || '').trim().toLowerCase() : '',
        'Digital message':         anyNotify ? 'yes' : 'no',  // lowercased for consistency with Notify email/SMS below
        'Unlock media URL':        form.attachmentURL || '',
        // Unlock short ID - the Worker stamps this on each /unlock record
        // (and the modal's upload response). Shopify Flow uses it to build
        // the recipient email's ?g=<id> direct-link so they don't have to
        // type the secret phrase. If the customer didn't upload media,
        // _uploadMeta is unset and we leave this empty - the email falls
        // back to bare /pages/unlock and the recipient identifies via
        // phrase or last-4 phone digits. 2026-05-28 wiring per
        // [[2026-05-28 · Same Skies · Cloudflare hardening + gift-media gap closed]].
        'Unlock short ID':         (form._uploadMeta && form._uploadMeta.shortId) || '',
        // QR target - tells the print template which payload to encode
        // on the printed card's QR code:
        //   "media"     → encode the Unlock media URL (photo/video unlock)
        //   "instagram" → encode https://instagram.com/sameskiesau as a
        //                 brand-fallback when no media was attached
        //   "none"      → printer should omit the QR entirely
        // We default to "instagram" when no media is attached so the
        // recipient always has something to discover when scanning.
        // The printer reads this attribute and selects which QR to render.

        // New v2 keys
        'Occasion':                form.occ || '',
        'Gift message':            (form.message || '').trim().slice(0, 280),
        'Message tone':            form.tone || '',
        'Hint enabled':            __hintOn ? 'yes' : 'no',
        // Unlock fallback - only set when SMS was actually opted in. Was
        // leaking the phone-number last-4 even when user typed phone +
        // unticked SMS. PII concern resolved by gating on form.smsUnlock.
        'Delivery speed':          '', // Clear legacy preference; this is not a purchased service.
        'Delivery preference':     'Choose shipping at checkout',
        'Notify email':            form.emailUnlock ? 'yes' : 'no',
        'Notify SMS':              form.smsUnlock ? 'yes' : 'no',

        // Clear the stale 'Skip gift message: true' flag that the cart
        // drawer's skip path writes - if a user skipped earlier then
        // came back to fill the gift, that key would persist and
        // mislead downstream Shopify Flow rules. Explicit clear here.
        'Skip gift message':       '',

        // Derived
        'Gift to':                 ((form.first || '').trim() + ' ' + (form.last || '').trim()).trim(),
      };

      // AUDIT (2026-05-26 - gift-media flow): log a diagnostic if the
      // hint/secret values changed AFTER the media upload completed.
      // The Worker's media record was created with the upload-time
      // hint/secret values; the cart attributes we're writing now have
      // the FINAL values. Until the Worker exposes a metadata-sync
      // endpoint (see Obsidian: gift-media flow audit), the admin
      // dashboard will show the upload-time values even though the
      // recipient unlock flow (driven by cart attributes via Shopify
      // Flow) uses the correct final values. Logging here makes the
      // discrepancy visible during QA without affecting customers.
      // AUDIT FIX (2026-05-28): backend sync now implemented. If hint/secret
      // (or any other field) diverged from upload-time values, POST a
      // /sync-metadata call to the Worker so the /pages/gift-media dashboard
      // sees the correct final values. Fire-and-forget - the cart-attribute
      // write is the source of truth for the recipient flow, so we don't
      // gate the checkout redirect on this sync. See:
      //   Claude Knowledge Bank/04 - Projects/Same Skies/Sessions/
      //     2026-05-26 · Same Skies · gift-media dashboard audit.md
      // (Option A).
      if (form._uploadMeta && form.attachmentURL) {
        var finalHint   = (__hintOn ? (form.hint || '').trim() : '');
        var finalSecret = (__hintOn ? (form.secretWord || '').trim().toLowerCase() : '');
        var finalRecipientName = ((form.first || '') + ' ' + (form.last || '')).trim();
        var finalRecipientEmail = (form.email || '').trim();
        var finalRecipientPhone = (form.phone || '').replace(/\D/g, '');
        var finalMessage = (form.message || '').trim();

        // Always sync the recipient + message data - even on first commit -
        // because upload-time customMetadata captures the moment of file
        // select, and the user typically fills the name AFTER. Cheap call,
        // worst case we re-write the same values.
        fetch(GM_WORKER_URL + '/sync-metadata', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            url:            form.attachmentURL,
            hint:           finalHint,
            secretWord:     finalSecret,
            recipientName:  finalRecipientName,
            recipientEmail: finalRecipientEmail,
            recipientPhone: finalRecipientPhone,
            message:        finalMessage,
            source:         'gift-modal-commit-sync',
          }),
          keepalive: true,  // survive the /checkout redirect
        }).then(function(r) {
          if (!r.ok) {
            // Don't error out - sync is best-effort. Log for QA visibility.
            console.warn('[gift-modal] /sync-metadata returned ' + r.status + ' - dashboard may show stale upload-time values');
          }
        }).catch(function(err) {
          console.warn('[gift-modal] /sync-metadata fetch failed (network) - dashboard may show stale upload-time values', err);
        });
      }

      gmSaveCart(attributes, live)
      .then(function(cart) {
        if (cart === null || !live()) return null;
        return gmFetchWithTimeout('/cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } })
          .then(function(r) { if (!r.ok) throw new Error('Basket could not be confirmed'); return r.json(); });
      })
      .then(function(cart) {
        if (cart === null || !live()) return;
        var saved = (cart && cart.attributes) || {};
        var mine = Object.keys(attributes).every(function(k) { return String(saved[k] || '') === String(attributes[k] || ''); });
        if (!mine) throw new Error('Gift details did not save');
        if (!cart || !Array.isArray(cart.items) || !cart.items.length || gmCartGate(cart)) throw new Error('Basket changed before checkout');
        // Re-emit cart:update so the header bubble (and any listeners) refresh.
        // Horizon's cart-icon reads itemCount ?? 0: without it the bag emptied
        // (and stored 0) just before checkout, so Back showed an empty bag.
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { source: 'gift-message-modal', itemCount: cart && cart.item_count } }
        }));
        // AUDIT FIX (2026-05-26): if the user dismissed the modal mid-save
        // (esc / backdrop / browser back), don't yank them to /checkout
        // anyway. Their cart attributes are saved (intentional - the data
        // is good even if they abandoned), but a forced redirect feels
        // hostile when they explicitly closed the modal.
        if (!live()) return;   // abandoned mid-save: the cancel already restored the button
        if (root.getAttribute('data-open') !== 'true') {
          // Restore the button so if they reopen the modal it isn't stuck
          // in "Saving…" forever.
          btn.removeAttribute('aria-disabled');
          btn.innerHTML = originalLabel;
          return;
        }
        // Redirect to checkout
        window.location.href = '/checkout';
      })
      .catch(function(err) {
        console.error('[gift-modal] commit error', err);
        if (!live()) return;
        btn.removeAttribute('aria-disabled');
        btn.style.minWidth = '';
        btn.innerHTML = originalLabel;
        showError(gmCartSaveUncertain ? gmCartSaveUnknownMessage : (err.gmSaveTimeout ? err.message : 'Could not save your gift details. Your draft is still here. Check your connection and try again.'), gmCartSaveUncertain);
      });
      }; // ── end __proceedCommit ──────────────────────────────────────────

      // Gate: mint a direct-link unlock record for ANY gift that has
      // deliverable content (a written message, a photo/video, a secret
      // phrase, or any notify channel) and we don't already hold a shortId.
      // CRITICAL (2026-06-01 GTM fix): previously this only minted when a
      // secret OR phone was present, so the MOST COMMON gift - "write a
      // message, maybe a photo, email it, no secret, no SMS" - minted no
      // shortId, the email link was bare /pages/unlock, and the recipient
      // dead-ended on the phone-lookup screen with no way in. Now every real
      // gift gets a working /pages/unlock?g=<id> link. A record with no
      // answer and no backup AUTO-REVEALS on load (unlock-message.liquid:847)
      // - correct for an ungated private-link gift. The order webhook (priority
      // 1) reconciles on this same id. A failed mint must keep the draft here:
      // a generic unlock URL cannot stand in for the recipient's private link.
      var __mintSender = (function () {
        var c = window.__ssGmCustomer;
        if (!c) return '';
        var n = ((c.firstName || '') + ' ' + (c.lastName || '')).trim();
        return n || (c.email || '');
      })();
      var __haveShortId  = !!(form._uploadMeta && form._uploadMeta.shortId);
      var __secretForMint = __hintOn ? (form.secretWord || '').trim() : '';
      var __mintMessage  = (form.message || '').trim();
      // Mint whenever the gift carries anything the recipient should receive.
      var __hasGift = !!(__mintMessage || form.attachmentURL || __secretForMint || anyNotify);
      if (!__haveShortId && __hasGift) {
        gmFetchWithTimeout(GM_WORKER_URL + '/unlock/create', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            answer:         __secretForMint,
            hint:           __hintOn ? (form.hint || '').trim() : '',
            // Phone backup is SMS-gated: only set the last-4 fallback when the
            // sender actually opted into SMS, so we never (a) surprise the
            // recipient with a phone field they were never told about, nor (b)
            // let the order webhook later wipe a backup the commit-time record
            // had. Mirrors recipientPhone's force-zero rule above.
            phone:          recipientPhone,
            message:        __mintMessage,
            from:           __mintSender,
            media:          form.attachmentURL || '',
            recipientEmail: recipientEmail,
            notifyEmail:    !!form.emailUnlock,
            notifySms:      !!form.smsUnlock
          })
        })
        .then(function (r) {
          if (!r.ok) throw new Error('Private gift link could not be created');
          return r.json();
        })
        .then(function (j) {
          if (!live()) return;
          if (j && j.shortId) {
            form._uploadMeta = form._uploadMeta || {};
            form._uploadMeta.shortId = j.shortId;
          } else {
            throw new Error('Private gift link was not returned');
          }
        })
        .then(__proceedCommit)
        .catch(function (err) {
          console.warn('[gift-modal] private link could not be saved', err);
          if (!live()) return;
          btn.removeAttribute('aria-disabled');
          btn.innerHTML = originalLabel;
          showError('We could not create your private gift link. Your draft is still here - check your connection and try again.');
        });
      } else {
        __proceedCommit();
      }
    });
  }

  // Expose internal helpers for B3-B10 to use without re-implementing them.
  // Kept on a single namespaced object to avoid polluting window.
  window.__gm = {
    getForm: function() { return form; },
    getStep: function() { return step; },
    setStep: setStep,
    advance: advance,
    showError: showError,
    markDirty: function() { dirty = true; },
    setRenderPreview: function(fn) { renderPreview = fn; }
  };

  // Initial render of preview panel
  renderPreview();

})();

